<template>
  <div class="mt-3">
    <div v-if="oferta && currentVersion" class="d-flex align-items-center justify-content-between p-3 bg-white border-bottom shadow-sm mb-0 rounded-top">
      <!-- Left filler to keep version centered -->
      <div class="flex-1" style="flex: 1;"></div>
      
      <div class="header-version-badge shadow-sm" :class="editandoProject ? (isMyLock ? 'bg-success' : 'bg-danger') : 'bg-success'">
        <i v-if="!editandoProject" class="fas fa-lock-open mr-2"></i>
        <i v-else class="fas fa-lock mr-2"></i>
        {{ currentVersion.revisionOferta }}
      </div>

      <!-- Right aligned actions -->
      <div class="d-flex align-items-center justify-content-end" style="flex: 1;">
        <div class="ganada-switch-wrapper mr-2 py-1 px-3 border rounded-pill bg-light d-flex align-items-center shadow-sm">
          <b-form-checkbox v-model="currentVersion.ganada" @change="handleGanadaChange" switch class="mb-0 custom-switch-success" :disabled="isReadOnly">
            <span :class="currentVersion.ganada ? 'text-success font-weight-bold' : 'text-secondary'" style="font-size: 0.85rem">Oferta Ganada</span>
          </b-form-checkbox>
        </div>
        
        <b-button variant="outline-info" size="sm" class="mr-2 shadow-sm rounded-pill px-3" @click="openChat">
          <i class="fas fa-comments mr-1"></i> Chat
        </b-button>

        <b-dropdown size="sm" variant="outline-primary" class="shadow-sm custom-dropdown" right>
          <template #button-content>
            <i class="fas fa-layer-group mr-1"></i> Versiones
          </template>
          <b-dropdown-item v-for="v in versionesOrdenadas" :key="v.id" @click="seleccionarVersion(v)" class="small dropdown-item-version">
            <div class="d-flex justify-content-between align-items-center w-100">
               <div>
                 <span class="mr-2">{{ v.revisionOferta }}</span>
                 <b-badge v-if="v.ganada" variant="success" pill>GANADA</b-badge>
               </div>
               <b-button size="sm" variant="link" class="text-danger p-0 ml-2 shadow-none border-0" @click.stop="confirmarBorrarVersion(v)" :disabled="isReadOnly">
                 <i class="fas fa-times-circle"></i>
               </b-button>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="clonarVersion" variant="info" class="small font-weight-bold" :disabled="isReadOnly">
            <i class="fas fa-clone mr-1"></i> Clonar esta versión
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-card no-body :class="{'rounded-top-0 border-top-0': oferta && currentVersion}">
      <b-tabs card v-model="tabIndex">
        <!-- Tab 1: Resumen (de la versión seleccionada) -->
        <b-tab title="Resumen" active>
          <b-alert v-if="isReadOnly" show variant="warning" class="mt-2 mb-0 py-2 small shadow-sm">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            Entrando en <strong>MODO LECTURA</strong> porque <strong>{{ empleadoEditando }}</strong> está editando la oferta.
          </b-alert>

          <b-form v-if="currentVersion" @submit.prevent="guardarVersion(false)">
            <div class="container cuerpoformulario" style="overflow-y: auto">
              <b-row class="mt-2 mb-3">
                <b-col cols="6">
                  <div class="d-flex align-items-center mb-1 pb-0">
                    <label for="cliente" class="form-label mb-0 mr-2">Cliente</label>
                    <b-button size="sm" variant="outline-success" @click="modalCliente" class="p-0 border-0 d-flex align-items-center justify-content-center bg-light" style="width: 20px; height: 20px; border-radius: 50%;" v-b-tooltip.hover title="Mantenimiento clientes">
                      <i class="fas fa-plus text-success" style="font-size: 0.75rem;"></i>
                    </b-button>
                  </div>
                  <b-form-select v-model="oferta.cliente" size="sm" value-field="id" text-field="nombre" required>
                    <option v-for="c in clientes" :key="c.id" :value="c">{{ c.nombre }}</option>
                  </b-form-select>
                </b-col>
                <b-col cols="3">
                  <label>CIF</label>
                  <b-form-input size="sm" :value="oferta.cliente ? oferta.cliente.cif : ''" readonly class="bg-light font-weight-bold"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <label>Revisión Oferta</label>
                  <b-form-input size="sm" v-model="currentVersion.revisionOferta" required></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col cols="3">
                  <label>Número Oferta</label>
                  <b-form-input size="sm" v-model="oferta.numeroOferta"></b-form-input>
                </b-col>
                <b-col cols="6">
                  <label>Nombre Oferta</label>
                  <b-form-input size="sm" v-model="oferta.nombreOferta"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <label>Estado</label>
                  <b-form-input size="sm" v-model="oferta.estado"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col>
                  <label>Persona de Contacto</label>
                  <b-form-input size="sm" v-model="oferta.contactoOferta"></b-form-input>
                </b-col>
                <b-col>
                  <label>Email contacto</label>
                  <b-form-input size="sm" v-model="oferta.emailContacto"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col>
                  <label>Título de la Oferta</label>
                  <b-form-textarea size="sm" v-model="oferta.alcance" rows="3" placeholder="Introduce el título de la oferta..."></b-form-textarea>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3">
                <b-col>
                  <label>Sector</label>
                  <b-form-select size="sm" v-model="oferta.sector" :options="optionsSectores"></b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col>
                  <label>Ciudad</label>
                  <b-form-input size="sm" v-model="oferta.ciudad"></b-form-input>
                </b-col>
                <b-col>
                  <label>País</label>
                  <b-form-input size="sm" v-model="oferta.pais"></b-form-input>
                </b-col>
                <b-col>
                  <label>Año</label>
                  <b-form-input size="sm" v-model="oferta.anyo"></b-form-input>
                </b-col>
              </b-row>

              <!-- Tabla Condiciones de Pago -->
              <div v-if="currentVersion" class="mt-5 mb-4" style="max-width: 100%; margin: 0 auto;">
                <div class="d-flex align-items-center mb-3">
                  <b-form-checkbox v-model="currentVersion.condicionesPagoIndependientes" switch class="mb-0 custom-switch-success font-weight-bold">
                    Condiciones de Pago Independientes por Ítem
                  </b-form-checkbox>
                </div>
                <div v-if="!currentVersion.condicionesPagoIndependientes">
                <div class="excel-row" style="background-color: #ffffff; border: 2px solid black; border-bottom: 1px solid black;">
                    <div style="flex: 0 0 80%; text-align: center; font-weight: bold; padding: 4px; border-right: 1px solid black; display: flex; align-items: center; justify-content: center;">
                      CONDICIONES DE PAGO
                      <b-button size="sm" variant="outline-success" v-b-modal.modal-condiciones-pago class="p-0 border-0 d-flex align-items-center justify-content-center bg-white shadow-sm ml-2" style="width: 22px; height: 22px; border-radius: 50%;" v-b-tooltip.hover title="Gestionar condiciones de pago">
                        <i class="fas fa-plus text-success" style="font-size: 0.8rem;"></i>
                      </b-button>
                    </div>
                    <div style="flex: 0 0 20%; background-color: #b7dee8; text-align: center; font-weight: bold; display: flex; align-items: center; padding-right: 5px;">
                        <b-form-select size="sm" v-model="currentVersion.condicionesPago" :options="optionsCondicionesPago" @input="actualizarHitos($event)" class="border-0 bg-transparent rounded-0 shadow-none text-center font-weight-bold" style="cursor: pointer;">
                            <template #first>
                                <b-form-select-option :value="null">-- Seleccionar --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button size="sm" variant="success" class="rounded-circle ml-1" style="width: 20px; height: 20px; padding: 0; min-width: 20px;" @click="$bvModal.show('modal-condiciones-pago')" v-b-tooltip.hover title="Gestionar plantillas">
                            <i class="fas fa-plus" style="font-size: 0.7rem;"></i>
                        </b-button>
                    </div>
                </div>
                
                <div v-for="(hito, idx) in currentVersion.hitosFacturacion" :key="idx" class="excel-row" :style="idx === currentVersion.hitosFacturacion.length - 1 ? 'border: 2px solid black; border-top: none; border-bottom: 2px solid black;' : 'border: 2px solid black; border-top: none; border-bottom: 1px solid black;'">
                  <div style="flex: 0 0 15%; text-align: right; padding-right: 10px; font-size: 0.85rem; display: flex; align-items: center; justify-content: flex-end; font-weight: bold;">HITO {{ idx + 1 }}</div>
                  <div style="flex: 0 0 10%; background-color: #d9d9d9; border-left: 1px solid black; border-right: 1px solid black; display: flex; align-items: center;">
                    <b-form-input size="sm" v-model="hito.porcentaje" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input>
                  </div>
                  <div style="flex: 0 0 37.5%; display: flex; align-items: center;">
                    <b-form-input size="sm" v-model="hito.descripcion" placeholder="Descripción (ES)" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input>
                  </div>
                  <div style="flex: 0 0 37.5%; border-left: 1px solid black; display: flex; align-items: center;">
                    <b-form-input size="sm" v-model="hito.description" placeholder="Description (EN)" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input>
                  </div>
                </div>
                

                </div>
              </div>

              <!-- Tabla Condiciones de Cobro -->
              <div class="mt-5 mb-4" style="max-width: 100%; margin: 0 auto;">
                <div class="excel-row" style="background-color: #ffffff; border: 2px solid black; border-bottom: 1px solid black;">
                    <div style="flex: 0 0 80%; text-align: center; font-weight: bold; padding: 4px; border-right: 1px solid black; display: flex; align-items: center; justify-content: center;">
                      CONDICIONES DE COBRO
                      <b-button size="sm" variant="outline-success" v-b-modal.modal-condiciones-cobro class="p-0 border-0 d-flex align-items-center justify-content-center bg-white shadow-sm ml-2" style="width: 22px; height: 22px; border-radius: 50%;" v-b-tooltip.hover title="Gestionar condiciones de cobro">
                        <i class="fas fa-plus text-success" style="font-size: 0.8rem;"></i>
                      </b-button>
                    </div>
                    <div style="flex: 0 0 20%; background-color: #b7dee8; text-align: center; font-weight: bold; display: flex; align-items: center;">
                        <b-form-select size="sm" v-model="currentVersion.condicionesCobro" :options="optionsCondicionesCobro" @input="actualizarHitosCobro($event)" class="border-0 bg-transparent rounded-0 shadow-none text-center font-weight-bold" style="cursor: pointer;">
                            <template #first>
                                <b-form-select-option :value="null">-- Seleccionar --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
                
                <!-- Hitos Dinámicos Cobro (Formato simplificado: solo un string, ahora con traducción) -->
                <div v-for="(hito, idx) in currentVersion.hitosCobro" :key="idx" class="excel-row" :style="idx === (currentVersion.hitosCobro.length - 1) ? 'border: 2px solid black; border-top: none; border-bottom: 2px solid black;' : 'border: 2px solid black; border-top: none; border-bottom: 1px solid black;'">
                  <div style="flex: 0 0 50%; display: flex; align-items: center; padding: 0 10px; border-right: 1px solid black;">
                    <b-form-input size="sm" v-model="hito.descripcion" class="border-0 bg-transparent rounded-0 shadow-none" placeholder="Descripción (ES)"></b-form-input>
                  </div>
                  <div style="flex: 0 0 50%; display: flex; align-items: center; padding: 0 10px;">
                    <b-form-input size="sm" v-model="hito.description" class="border-0 bg-transparent rounded-0 shadow-none" placeholder="Description (EN)"></b-form-input>
                  </div>
                </div>
              </div>

              <!-- Ampliaciones -->
              <div class="mt-5 mb-4" style="max-width: 100%; margin: 0 auto;">
                <div class="excel-row font-weight-bold" style="background-color: #e2efda; border: 2px solid black;">
                  <div style="padding: 4px 8px;">AMPLIACIONES</div>
                </div>
                <div class="excel-row" style="background-color: #ffffff; border: 2px solid black; border-top: none;">
                  <div style="flex: 0 0 30%; padding: 4px 8px; border-right: 1px solid black; background-color: #f8f9fa;">Número ampliación</div>
                  <div style="flex: 1; display: flex; align-items: center; background-color: #b7dee8;">
                    <b-form-input size="sm" v-model="nuevaAmpliacionNumero" class="border-0 bg-transparent rounded-0 shadow-none text-center font-weight-bold" @keyup.enter="agregarAmpliacion"></b-form-input>
                    <b-button size="sm" variant="success" @click="agregarAmpliacion" class="ml-auto mr-1 py-0 px-2 d-flex align-items-center" style="height: 24px; border-radius: 4px;">
                      <i class="fas fa-plus mr-1" style="font-size: 0.7rem;"></i> Añadir
                    </b-button>
                  </div>
                </div>

                <div v-if="currentVersion.ampliaciones && currentVersion.ampliaciones.length > 0" class="mt-1 shadow-sm">
                  <div v-for="(amp, idx) in currentVersion.ampliaciones" :key="idx" class="excel-row" style="background-color: #ffffff; border: 1px solid #dee2e6; border-top: none;">
                    <div style="flex: 0 0 10%; padding: 4px 8px; border-right: 1px solid #dee2e6; background-color: #f8f9fa; font-weight: bold; text-align: center;">{{ idx + 1 }}</div>
                    <div style="flex: 1; padding: 4px 12px; display: flex; justify-content: space-between; align-items: center;">
                      <span class="font-weight-bold">{{ amp }}</span>
                      <b-button size="sm" variant="link" class="text-danger p-0 shadow-none border-0" @click="eliminarAmpliacion(idx)" v-b-tooltip.hover title="Eliminar ampliación">
                        <i class="fas fa-trash-alt"></i>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Comisión Comercial -->
              <div class="mt-4 mb-3 px-2">
                <b-row align-v="center">
                  <b-col md="5">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox v-model="currentVersion.comisionComercial" switch class="custom-switch-success font-weight-bold mr-3">
                        Comisión Comercial
                      </b-form-checkbox>
                      <span v-if="currentVersion.comisionComercial" class="small text-muted italic">
                        (Aplicado un {{ defaultCommissionRate }}% por defecto)
                      </span>
                    </div>
                  </b-col>
                  <b-col md="7" v-if="currentVersion.comisionComercial">
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="mr-2 small font-weight-bold text-secondary text-uppercase">Tanto por cien (%):</span>
                      <b-form-input 
                        type="number" 
                        step="0.01" 
                        v-model="currentVersion.porcentajeComisionComercial" 
                        size="sm"
                        style="max-width: 80px;"
                        class="bg-white font-weight-bold text-center mr-3"
                      ></b-form-input>
                      
                      <span class="mr-2 small font-weight-bold text-secondary text-uppercase">Importe Comisión:</span>
                      <b-form-input 
                        type="number" 
                        step="0.01" 
                        v-model="currentVersion.importeComisionComercial" 
                        readonly 
                        size="sm"
                        style="max-width: 130px;"
                        class="bg-light font-weight-bold text-primary text-right"
                      ></b-form-input>
                      <span class="ml-2 font-weight-bold">€</span>
                    </div>
                  </b-col>
                </b-row>
              </div>

            </div>
            <div class="d-flex justify-content-end mt-3">
              <b-button variant="secondary" @click="volverAOfertas" class="mr-2">Cancelar</b-button>
              <b-button variant="success" type="submit" :disabled="isReadOnly">Guardar</b-button>
            </div>
          </b-form>
          <div v-else class="text-center p-4">
            Selecciona una versión para ver los detalles.
          </div>
        </b-tab>

        <!-- Tab 2: Items -->
        <b-tab title="Items">
          <div v-if="currentVersion" class="pt-2">
             <div class="d-flex justify-content-between align-items-center mb-3 pb-3" style="border-bottom: 1px solid #eaeaea;">
                <h5 class="mb-0 text-secondary" style="font-weight: 400;">Items de la Versión {{ currentVersion.revisionOferta }}</h5>
                <div class="d-flex align-items-center">
                  <b-button variant="outline-indigo" size="sm" @click="abrirModalClonOferta" class="shadow-sm px-3 mr-2 btn-clonar-custom" :disabled="isReadOnly">
                    <i class="fas fa-clone mr-1"></i> Clonar Item de otra Oferta
                  </b-button>
                  <b-button variant="success" size="sm" @click="nuevoItem" class="shadow-sm px-3" :disabled="isReadOnly">Añadir Item</b-button>
                </div>
             </div>
             <b-table small hover :fields="itemFields" :items="standardItems">
                <template #cell(seleccionado)="row">
                   <div class="d-flex justify-content-center align-items-center" style="min-height: 32px;">
                      <input type="checkbox" v-model="row.item.seleccionado" @change="guardarVersion(true)" style="width: 18px; height: 18px; cursor: pointer;" />
                   </div>
                </template>
                <template #cell(importeItem)="row">
                   <div class="text-nowrap">{{ getQuotationPrice(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                </template>
                <template #cell(comision)="row">
                   <div class="text-nowrap text-info">{{ getItemCommission(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                </template>
                <template #cell(totalConComision)="row">
                   <div class="text-nowrap font-weight-bold text-primary">{{ getItemTotalWithCommission(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                </template>
                <template #cell(orden)="row">
                   <div class="d-flex flex-nowrap justify-content-center">
                     <b-button size="sm" variant="outline-secondary" @click="moverItemArriba(row.index, false)" class="mr-1" :disabled="isReadOnly || row.index === 0" title="Subir">
                        <i class="fas fa-arrow-up"></i>
                     </b-button>
                     <b-button size="sm" variant="outline-secondary" @click="moverItemAbajo(row.index, false)" class="mr-1" :disabled="isReadOnly || row.index === standardItems.length - 1" title="Bajar">
                        <i class="fas fa-arrow-down"></i>
                     </b-button>
                   </div>
                </template>
                <template #cell(accion)="row">
                   <div class="d-flex flex-nowrap justify-content-center">
                     <b-button size="sm" :variant="isReadOnly ? 'outline-info' : 'outline-primary'" @click="editarItem(row.item)" class="mr-1" :title="isReadOnly ? 'Ver detalle' : 'Editar'">
                        <i :class="isReadOnly ? 'fas fa-eye' : 'fas fa-edit'"></i>
                     </b-button>
                     <b-button size="sm" variant="outline-danger" @click="eliminarItem(row.item)" :disabled="isReadOnly">
                        <i class="fas fa-trash-alt"></i>
                     </b-button>
                   </div>
                </template>
             </b-table>
             <div class="d-flex justify-content-end mb-4 pr-3">
                <div class="text-right">
                   <span class="text-muted small font-weight-bold mr-2 text-uppercase">TOTAL OFERTA:</span>
                   <span class="h5 font-weight-bold text-dark">{{ totalStandardItemsCalculado.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} €</span>
                </div>
             </div>

             <!-- Tabla Items Opcionales -->
             <div v-if="optionalItems.length > 0" class="mt-5">
               <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                 <h6 class="mb-0 text-secondary font-weight-bold">Opcionales</h6>
               </div>
               <b-table small hover :fields="itemFields" :items="optionalItems" class="table-opcionales">
                   <template #cell(seleccionado)="row">
                      <div class="d-flex justify-content-center align-items-center" style="min-height: 32px;">
                         <input type="checkbox" v-model="row.item.seleccionado" @change="guardarVersion(true)" style="width: 18px; height: 18px; cursor: pointer;" />
                      </div>
                   </template>
                   <template #cell(importeItem)="row">
                      <div class="text-nowrap">{{ getQuotationPrice(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                   </template>
                   <template #cell(comision)="row">
                      <div class="text-nowrap text-info">{{ getItemCommission(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                   </template>
                   <template #cell(totalConComision)="row">
                      <div class="text-nowrap font-weight-bold text-primary">{{ getItemTotalWithCommission(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €</div>
                   </template>
                   <template #cell(orden)="row">
                      <div class="d-flex flex-nowrap justify-content-center">
                        <b-button size="sm" variant="outline-secondary" @click="moverItemArriba(row.index, true)" class="mr-1" :disabled="isReadOnly || row.index === 0" title="Subir">
                           <i class="fas fa-arrow-up"></i>
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" @click="moverItemAbajo(row.index, true)" class="mr-1" :disabled="isReadOnly || row.index === optionalItems.length - 1" title="Bajar">
                           <i class="fas fa-arrow-down"></i>
                        </b-button>
                      </div>
                   </template>
                   <template #cell(accion)="row">
                      <div class="d-flex flex-nowrap justify-content-center">
                        <b-button size="sm" :variant="isReadOnly ? 'outline-info' : 'outline-primary'" @click="editarItem(row.item)" class="mr-1" :title="isReadOnly ? 'Ver detalle' : 'Editar'">
                           <i :class="isReadOnly ? 'fas fa-eye' : 'fas fa-edit'"></i>
                        </b-button>
                        <b-button size="sm" variant="outline-danger" @click="eliminarItem(row.item)" :disabled="isReadOnly">
                           <i class="fas fa-trash-alt"></i>
                        </b-button>
                      </div>
                   </template>
               </b-table>
             </div>

             <!-- Gráficos de Horas -->
             <div class="mt-5 mb-4 px-3" v-if="currentVersion.items && currentVersion.items.length > 0">
               <div class="d-flex justify-content-between align-items-center mb-4">
                 <h6 class="font-weight-bold mb-0">GRÁFICO HORAS</h6>
                 <div class="d-flex align-items-center">
                   <span class="mr-2">Ver horas</span>
                   <b-form-select size="sm" v-model="chartViewMode" style="width: 150px; background-color: #bce4e8;" class="border-0 shadow-none font-weight-bold">
                     <b-form-select-option value="TOTAL">TOTALES</b-form-select-option>
                     <b-form-select-option v-for="item in currentVersion.items" :key="item.id" :value="item.numeroItem">Item 0{{ item.numeroItem }}</b-form-select-option>
                   </b-form-select>
                 </div>
               </div>

               <b-row>
                 <!-- Left Column: Bar Chart + Data Table -->
                 <b-col md="8">
                   <div style="height: 300px; margin-bottom: 20px;">
                     <bar-chart :chart-data="barChartData" :chart-options="barChartOptions"></bar-chart>
                   </div>
                   
                   <div class="excel-table shadow-sm" style="border: 1px solid #ccc; font-size: 0.85rem;">
                     <div class="excel-row text-center bg-white" style="border-bottom: 1px solid #ccc;">
                       <div style="flex: 0 0 16%; padding: 4px; border-right: 1px solid #ccc;"></div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">LS / Principal</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">Senior</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">Junior</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">Deliniante</div>
                       <div style="flex: 1; padding: 4px;">Becario</div>
                     </div>
                     <div class="excel-row text-center" style="background-color: #e6e6e6; border-bottom: 1px solid #ccc;">
                       <div style="flex: 0 0 16%; padding: 4px; border-right: 1px solid #ccc; background-color: #fff; text-align: right; padding-right: 10px;">horas</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.principal.horas }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.senior.horas }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.junior.horas }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.delineante.horas }}</div>
                       <div style="flex: 1; padding: 4px;">{{ processedChartData.becario.horas }}</div>
                     </div>
                     <div class="excel-row text-center" style="background-color: #e6e6e6;">
                       <div style="flex: 0 0 16%; padding: 4px; border-right: 1px solid #ccc; background-color: #fff; text-align: right; padding-right: 10px;">dias</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.principal.dias }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.senior.dias }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.junior.dias }}</div>
                       <div style="flex: 1; padding: 4px; border-right: 1px solid #ccc;">{{ processedChartData.delineante.dias }}</div>
                       <div style="flex: 1; padding: 4px;">{{ processedChartData.becario.dias }}</div>
                     </div>
                   </div>
                 </b-col>
                 
                 <!-- Right Column: Pie Chart -->
                 <b-col md="4" class="d-flex align-items-center justify-content-center">
                   <div style="height: 300px; width: 100%;">
                     <pie-chart :chart-data="pieChartData" :chart-options="pieChartOptions"></pie-chart>
                   </div>
                 </b-col>
               </b-row>
             </div>
             
          </div>
          <div v-else class="text-center p-4">
            Selecciona una versión para gestionar los items.
          </div>
        </b-tab>

        <!-- Tab 3: Plantilla -->
        <b-tab title="Plantilla">
          <div v-if="currentVersion" class="p-4">
            <b-row>
              <b-col md="12" class="d-flex justify-content-between align-items-center mb-4">
                <h5 class="mb-0 text-secondary">Configuración Plantilla Oferta</h5>
                <b-form-checkbox v-model="currentVersion.ingles" name="check-ingles" switch class="font-weight-bold">
                   Inglés (PDF)
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-card class="shadow-sm border-0 bg-light">
              <b-row class="mb-3">
                <b-col md="12">
                  <h6 class="text-uppercase text-secondary font-weight-bold border-bottom pb-2 mt-2">
                     <i class="fas fa-building mr-2 text-primary"></i> Datos del Cliente (PDF)
                  </h6>
                  
                </b-col>
                <b-col md="6">
                  <b-form-group label="Dirección" label-class="font-weight-bold small">
                     <b-form-input v-model="currentVersion.direccionClienteMemoria" placeholder="Ej: Calle Gran Vía 12" class="bg-white rounded" />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Código Postal" label-class="font-weight-bold small">
                     <b-form-input v-model="currentVersion.cpClienteMemoria" placeholder="Ej: 28013" class="bg-white rounded" />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Población" label-class="font-weight-bold small">
                     <b-form-input v-model="currentVersion.poblacionClienteMemoria" placeholder="Ej: Madrid" class="bg-white rounded" />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="País" label-class="font-weight-bold small">
                     <b-form-input v-model="currentVersion.paisClienteMemoria" placeholder="Ej: España" class="bg-white rounded" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col md="12">
                  <h6 class="text-uppercase text-secondary font-weight-bold border-bottom pb-2 mt-2">
                     <i class="fas fa-file-alt mr-2 text-info"></i> Notas
                  </h6>
                  <b-form-group label-class="font-weight-bold small text-uppercase text-secondary p-0 m-0">
                    <template #label>
                      <div class="d-flex align-items-center">
                        <span class="mr-3">Notas Oferta</span>
                        <b-form-checkbox v-model="includeTravelNotes" @change="toggleTravelNotes" plain class="mb-0 ml-2" style="font-size: 0.8rem; font-weight: normal; text-transform: none; color: #6c757d; white-space: nowrap;">
                          Incluir texto gastos viaje
                        </b-form-checkbox>
                      </div>
                    </template>
                    <b-form-textarea
                      v-model="currentVersion.notasOferta"
                      placeholder="Introduce las notas que aparecerán en el alcance de los trabajos..."
                      rows="3"
                      class="bg-white rounded"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col md="12">
                  <h6 class="text-uppercase text-secondary font-weight-bold border-bottom pb-2 mt-2">
                     <i class="fas fa-gavel mr-2 text-warning"></i> Condiciones de Venta
                  </h6>
                  <b-form-group label="Texto Condiciones de Venta" label-class="font-weight-bold small text-uppercase text-secondary">
                    <b-form-textarea
                      v-model="currentVersion.condicionesVenta"
                      placeholder="Introduce las condiciones de venta..."
                      rows="6"
                      class="bg-white rounded"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4 align-items-center">
                <b-col md="12" class="text-right">
                  <b-button variant="danger" @click="generarPdfMake" class="shadow-sm font-weight-bold px-4">
                    <i class="fas fa-file-pdf mr-2"></i> Generar PDF
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <div class="alert alert-info py-2" style="font-size: 0.85rem;">
                    Las notas escritas aquí aparecerán directamente en el PDF generado.
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <div class="d-flex justify-content-end mt-4">
              <b-button variant="secondary" @click="volverAOfertas" class="mr-2">Cancelar</b-button>
              <b-button variant="success" @click="guardarVersion(false)" :disabled="isReadOnly">Guardar Cambios</b-button>
            </div>
          </div>
          <div v-else class="text-center p-4">
            Selecciona una versión para configurar la plantilla.
          </div>
        </b-tab>

        <!-- Tab 4: Documentos -->
        <b-tab title="Documentos">
          <div v-if="currentVersion" class="p-4">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
              <h5 class="mb-0 text-secondary">Documentos y Emails Adjuntos</h5>
              <b-spinner v-if="isUploading" small variant="primary" label="Subiendo..."></b-spinner>
            </div>

            <div 
              class="dropzone mb-4" 
              :class="{'active': dragActive}"
              @dragover.prevent="dragActive = true"
              @dragleave.prevent="dragActive = false"
              @drop.prevent="handleFileDrop"
              @click="$refs.fileInput.click()"
            >
              <i class="fas fa-cloud-upload-alt fa-3x mb-3 text-primary"></i>
              <h5 class="font-weight-bold">Arrastra aquí tus archivos o haz clic para seleccionar</h5>
              <p class="text-muted small">Puedes arrastrar emails directamente desde Outlook (se guardarán como archivos .msg)</p>
              <input type="file" ref="fileInput" @change="handleFileSelect" multiple hidden />
            </div>

            <div v-if="oferta.documentos && oferta.documentos.length > 0" class="file-list">
              <div v-for="(doc, idx) in oferta.documentos" :key="idx" class="file-item shadow-sm">
                <div class="mr-3" style="font-size: 1.5rem;">
                  <i :class="getFileIcon(doc.tipo)"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-dark">{{ doc.nombre }}</div>
                  <div class="small text-muted">{{ doc.tipo.toUpperCase() }}</div>
                </div>
                <div class="actions">
                  <b-button size="sm" variant="outline-primary" class="mr-2" @click="downloadDocument(doc)" title="Descargar">
                    <i class="fas fa-download"></i>
                  </b-button>
                  <b-button size="sm" variant="outline-danger" @click="removeDocument(idx)" title="Eliminar" :disabled="isReadOnly">
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-5 bg-light rounded border">
              <i class="fas fa-file-invoice fa-3x mb-3 text-muted"></i>
              <p class="text-muted mb-0">No hay documentos adjuntos en esta oferta.</p>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- Modal para Item -->
    <b-modal ref="item-modal" title="Datos del Item" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
       <b-form @submit.prevent="guardarItem">
          <b-card no-body class="mb-4" style="border: 1px solid black;">
            <div class="excel-row">
              <div class="excel-label font-weight-bold" style="background-color: #b7dee8; justify-content: center; font-size: 1.1rem; flex: 0 0 25%;">
                ITEM <b-form-input size="sm" v-model="formItem.numeroItem" class="ml-2 border-0 bg-transparent rounded-0 shadow-none font-weight-bold" style="width: 100px; font-size: 1.1rem;"></b-form-input>
              </div>
              <div class="excel-val d-flex align-items-center bg-light border-right border-dark" style="flex: 0 0 45%; padding-left: 10px;">
                <label class="mb-0 mr-2 small font-weight-bold">{{ formItem.opcional ? 'Opcional:' : 'Categoría Precios:' }}</label>
                <template v-if="!formItem.opcional">
                  <b-form-select size="sm" v-model="selectedPriceCategoryId" :options="priceCategories" value-field="id" text-field="nombre" @change="applyPriceCategory" class="mr-2" style="max-width: 200px;">
                    <template #first>
                      <b-form-select-option :value="null">-- Seleccionar --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-button size="sm" variant="outline-success" @click="modalPrecioHora" class="p-0 border-0 d-flex align-items-center justify-content-center bg-white shadow-sm" style="width: 22px; height: 22px; border-radius: 50%;" v-b-tooltip.hover title="Gestionar categorías de precios">
                    <i class="fas fa-plus text-success" style="font-size: 0.8rem;"></i>
                  </b-button>
                </template>
                <template v-else>
                  <b-form-select size="sm" v-model="formItem.opcionalTemplateId" :options="opcionalesTemplates" value-field="id" text-field="nombreOpcional" @change="applyOpcionalTemplate" class="mr-2" style="max-width: 200px;">
                    <template #first>
                      <b-form-select-option :value="null">-- Seleccionar opcional --</b-form-select-option>
                    </template>
                  </b-form-select>
                </template>
              </div>
              <div class="excel-val-full d-flex align-items-center justify-content-end pr-3" style="background-color: #e2efda; font-weight: bold; flex: 1;">
                <span class="mr-3">QUOTATION PRICE</span>
                <span class="text-right font-weight-bold">{{ quotationPrice }} €</span>
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label">Tipo proyecto</div>
              <div class="excel-val"><b-form-select size="sm" v-model="formItem.tipoProyecto" :options="optionsTipoProyecto" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-select></div>
              <div class="excel-label">Tipo servicio</div>
              <div class="excel-val"><b-form-select size="sm" v-model="formItem.tipoServicio" :options="optionsTipoServicio" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-select></div>
            </div>
            <div class="excel-row">
              <div class="excel-label">Fecha Primera Entrega</div>
              <div class="excel-val"><b-form-input type="date" size="sm" v-model="formItem.fechaPrimeraEntrega" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
              <div class="excel-label">Consultoria por horas</div>
              <div class="excel-val d-flex align-items-center" style="padding-left: 12px;">
                <input type="checkbox" v-model="formItem.consultoriaPorHoras" @change="toggleConsultoria" style="width: 18px; height: 18px;" />
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label font-weight-bold text-primary">Descuento Global</div>
              <div class="excel-val d-flex align-items-center" style="padding-left: 12px;">
                <input type="checkbox" v-model="formItem.esDescuento" style="width: 18px; height: 18px;" @change="updateTotals" />
              </div>
              <div class="excel-label">% Descuento</div>
              <div class="excel-val">
                <b-form-input type="number" step="0.01" size="sm" v-model="formItem.porcentajeDescuento" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input>
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label font-weight-bold text-success">Opcional</div>
              <div class="excel-val d-flex align-items-center" style="padding-left: 12px; flex: 0 0 10%; border-right: 1px solid black;">
                <input type="checkbox" v-model="formItem.opcional" style="width: 18px; height: 18px;" @change="recalculateItemNumber" />
              </div>
              <div class="excel-label font-weight-bold" style="flex: 0 0 10%;">Nº pedido</div>
              <div class="excel-val" style="flex: 0 0 20%; border-right: 1px solid black;">
                <b-form-input size="sm" v-model="formItem.numeroPedido" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input>
              </div>
              <div class="excel-label font-weight-bold" style="flex: 0 0 10%;">Cuasipedido</div>
              <div class="excel-val d-flex align-items-center" style="padding-left: 12px; flex: 1;">
                <input type="checkbox" v-model="formItem.cuasiPedido" style="width: 18px; height: 18px;" />
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label font-weight-bold">Descripción ITEM</div>
              <div class="excel-val" style="flex: 1;"><b-form-input size="sm" v-model="formItem.descripcion" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
              <div class="excel-label font-weight-bold" style="flex: 0 0 20%;">Aceptado para Proyecto</div>
              <div style="flex: 0 0 10%; padding-left: 12px;" class="excel-val d-flex align-items-center">
                <b-form-checkbox v-model="formItem.seleccionado" switch class="mb-0 custom-switch-success"></b-form-checkbox>
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label font-weight-bold">Description (for project)</div>
              <div class="excel-val-full">
                <b-form-input size="sm" v-model="formItem.description" placeholder="This description will be sent to the Project Item" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input>
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label">Notas ITEM</div>
              <div class="excel-val-full"><b-form-input size="sm" v-model="formItem.notasItem" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
            </div>
            <div class="excel-row" v-if="currentVersion && currentVersion.condicionesPagoIndependientes && !formItem.esDescuento">
              <div class="excel-label font-weight-bold" style="background-color: #fce4d6;">Condiciones de Pago</div>
              <div class="excel-val-full d-flex align-items-center" style="background-color: #fce4d6; padding-right: 5px;">
                  <b-form-select size="sm" v-model="formItem.condicionesPago" :options="optionsCondicionesPago" @input="actualizarHitosItem($event)" class="border-0 bg-transparent rounded-0 shadow-none font-weight-bold" style="cursor: pointer;">
                      <template #first>
                          <b-form-select-option :value="null">-- Seleccionar --</b-form-select-option>
                      </template>
                  </b-form-select>
                  <b-button size="sm" variant="success" class="rounded-circle ml-1" style="width: 22px; height: 22px; padding: 0; min-width: 22px;" @click="$bvModal.show('modal-condiciones-pago')" v-b-tooltip.hover title="Gestionar plantillas">
                      <i class="fas fa-plus" style="font-size: 0.75rem;"></i>
                  </b-button>
              </div>
            </div>
            <div class="excel-row">
              <div class="excel-label font-weight-bold">Info Fase oferta</div>
              <div class="excel-val-full"><b-form-input size="sm" v-model="formItem.infoFaseOferta" placeholder="RECUERDA DEJAR LAS NOTAS RELEVANTES" class="border-0 bg-transparent rounded-0 shadow-none text-danger font-weight-bold"></b-form-input></div>
            </div>
          </b-card>

          <!-- New Consulting Table (only if consultoriaPorHoras is true) -->
          <b-card no-body class="mb-4" style="border: 1px solid black;" v-if="formItem.consultoriaPorHoras && !formItem.esDescuento">
              <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
                <div style="flex: 1; padding: 4px 12px;">Definición de Tarifa (Modo Consultoría)</div>
              </div>
              <div class="excel-row">
                <div class="excel-label font-weight-bold" style="background-color: #f2f2f2;">Importe por Unidad (€)</div>
                <div class="excel-val"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.importeUnidad" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center font-weight-bold"></b-form-input></div>
                <div class="excel-label font-weight-bold" style="background-color: #f2f2f2;">Unidad (ej: /h, /visita)</div>
                <div class="excel-val"><b-form-input size="sm" v-model="formItem.unidadPrecio" class="border-0 bg-transparent rounded-0 shadow-none font-weight-bold px-2" placeholder="Ej: /h, /visita"></b-form-input></div>
              </div>
          </b-card>

          <!-- Personnel and indirect costs Table -->
          <b-card no-body class="mb-4" style="border: 1px solid black;" v-if="!formItem.esDescuento && !formItem.consultoriaPorHoras">
            <!-- Header Row -->
            <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-bottom: 2px solid black;">
              <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Item Work stream</div>
              <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;">Staff leading</div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">Hour</div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">Rate (€/h)</div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">Total</div>
              <div style="flex: 1; padding: 4px 12px;">Comment</div>
            </div>
            <!-- Section Title Row -->
            <div class="excel-row font-weight-bold" style="background-color: #e2efda;">
              <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;" class="d-flex align-items-center">
                1. Personnel and indirect costs
                <b-button variant="success" size="sm" class="rounded-circle ml-2 p-0" style="width: 24px; height: 24px;" @click="abrirDesgloseActividades">
                  <i class="fas fa-plus"></i>
                </b-button>
              </div>
              <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ totalPersonnelCosts }} €</div>
            </div>
            <!-- Roles Rows -->
            <!-- Principal -->
            <div class="excel-row" style="background-color: #ffffff;">
              <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Principal, LS, ETC</div>
              <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.horasPrincipal" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center" readonly></b-form-input></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.tarifaPrincipal" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat((formItem.horasPrincipal * formItem.tarifaPrincipal).toFixed(2)) }}</div>
              <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.comentarioPrincipal" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
            </div>
            <!-- Senior -->
            <div class="excel-row" style="background-color: #ffffff;">
              <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Senior (>5 years)</div>
              <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.horasSenior" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center" readonly></b-form-input></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.tarifaSenior" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat((formItem.horasSenior * formItem.tarifaSenior).toFixed(2)) }}</div>
              <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.comentarioSenior" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
            </div>
            <!-- Junior -->
            <div class="excel-row" style="background-color: #ffffff;">
              <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Junior</div>
              <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.horasJunior" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center" readonly></b-form-input></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.tarifaJunior" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat((formItem.horasJunior * formItem.tarifaJunior).toFixed(2)) }}</div>
              <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.comentarioJunior" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
            </div>
            <!-- Delineante -->
            <div class="excel-row" style="background-color: #ffffff;">
              <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Deliniante ó Tec. Elearning</div>
              <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.01" size="sm" v-model="actualDelineanteHours" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center" readonly></b-form-input></div>
              <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.tarifaDelineante" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
              <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat((actualDelineanteHours * formItem.tarifaDelineante).toFixed(2)) }}</div>
              <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.comentarioDelineante" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
            </div>
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black;">Sub-total</div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ totalPersonnelHours }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ totalPersonnelCosts }}</div>
               <div style="flex: 1;"></div>
             </div>
           </b-card>

           <!-- 2. Subcontracts Table -->
           <b-card no-body class="excel-table mb-4" style="border: 1px solid black; border-radius: 0;" v-if="!formItem.esDescuento && !formItem.consultoriaPorHoras">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">2. Subcontracts</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ totalSubcontractsCosts }} €</div>
             </div>
             <!-- Third-party assistance -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Third-party assistance</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.qtyThirdParty" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.priceThirdParty" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyThirdParty) || 0) * (Number(formItem.priceThirdParty) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentThirdParty" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Translation costs -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Translation costs</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.qtyTranslation" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.priceTranslation" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyTranslation) || 0) * (Number(formItem.priceTranslation) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentTranslation" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Others -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Others</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.qtyOtherSubcalc" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.priceOtherSubcalc" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyOtherSubcalc) || 0) * (Number(formItem.priceOtherSubcalc) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentOtherSubcalc" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Sub-total Subcontracts -->
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black;">Sub-total</div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ (Number(formItem.qtyThirdParty)||0) + (Number(formItem.qtyTranslation)||0) + (Number(formItem.qtyOtherSubcalc)||0) }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ totalSubcontractsCosts }}</div>
               <div style="flex: 1;"></div>
             </div>
           </b-card>

           <!-- 3. Travel Expenses Table -->
           <b-card no-body class="excel-table mb-4" style="border: 1px solid black; border-radius: 0;" v-if="!formItem.esDescuento && !formItem.consultoriaPorHoras">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">
                 3. Travel expenses 
                 <b-button size="sm" variant="success" class="rounded-circle ml-2" style="width: 24px; height: 24px; padding: 0;" @click="abrirDesgloseViajes">
                   <i class="fas fa-plus"></i>
                 </b-button>
               </div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ totalTravelCosts }} €</div>
             </div>
             <!-- Travel time rows -->
             <div v-for="role in [{label:'Travel time - LS/Principal', q:'qtyTravelLS', r:'rateTravelLS', c:'commentTravelLS'}, {label:'Travel time - Senior', q:'qtyTravelSenior', r:'rateTravelSenior', c:'commentTravelSenior'}, {label:'Travel time - Junior', q:'qtyTravelJunior', r:'rateTravelJunior', c:'commentTravelJunior'}]" :key="role.label" class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">{{ role.label }}</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="any" size="sm" v-model="formItem[role.q]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-form-input type="number" step="any" size="sm" v-model="formItem[role.r]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem[role.q]) || 0) * (Number(formItem[role.r]) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem[role.c]" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Flight specific row with select -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Flight / Train / Bus</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtyFlight" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateFlight" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyFlight) || 0) * (Number(formItem.rateFlight) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;" class="d-flex align-items-center">
                   <b-form-select size="sm" v-model="formItem.commentFlight" :options="transportExpenseOptions" @change="onTravelExpenseSelect('Flight', $event)" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-select>
                   <b-button size="sm" variant="link" class="p-0 ml-1 text-success" @click="openTravelExpensesModal('transporte')">
                     <i class="fas fa-plus-circle"></i>
                   </b-button>
                 </div>
             </div>
             <!-- Car rental and other specific rows -->
             <div v-for="row in [{label:'Car rental', q:'qtyCarRental', r:'rateCarRental', c:'commentCarRental'}]" :key="row.label" class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">{{ row.label }}</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem[row.q]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem[row.r]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem[row.q]) || 0) * (Number(formItem[row.r]) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;" class="d-flex align-items-center">
                   <b-form-select size="sm" v-model="formItem[row.c]" :options="transportExpenseOptions" @change="onTravelExpenseSelect('CarRental', $event)" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-select>
                   <b-button size="sm" variant="link" class="p-0 ml-1 text-success" @click="openTravelExpensesModal('transporte')">
                     <i class="fas fa-plus-circle"></i>
                   </b-button>
                 </div>
             </div>
             <!-- Fuel (Special: Blue Total column) -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Fuel</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.priceFuel" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ formItem.priceFuel }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentFuel" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Qty * Rate rows -->
             <div v-for="row in [{label:'Km with OWN car', q:'qtyKmOwnCar', r:'rateKmOwnCar', c:'commentKmOwnCar'}, {label:'Tolls', q:'qtyTolls', r:'rateTolls', c:'commentTolls'}, {label:'Taxi', q:'qtyTaxi', r:'rateTaxi', c:'commentTaxi'}, {label:'Living Allowances', q:'qtyLivingAllowances', r:'rateLivingAllowances', c:'commentLivingAllowances'}]" :key="row.label" class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">{{ row.label }}</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem[row.q]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem[row.r]" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem[row.q]) || 0) * (Number(formItem[row.r]) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem[row.c]" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Hotel (Dedicated: with dropdown and + button) -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Hotel</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtyHotel" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateHotel" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyHotel) || 0) * (Number(formItem.rateHotel) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;" class="d-flex align-items-center">
                   <b-form-select size="sm" v-model="formItem.commentHotel" :options="hotelExpenseOptions" @change="onTravelExpenseSelect('Hotel', $event)" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-select>
                   <b-button size="sm" variant="link" class="p-0 ml-1 text-success" @click="openTravelExpensesModal('hotel')">
                     <i class="fas fa-plus-circle"></i>
                   </b-button>
                 </div>
             </div>
             <!-- Visa (Special: Blue Total column) -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black;">Visa</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.priceVisa" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ formItem.priceVisa }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentVisa" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Sub-total Travel -->
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black;">Sub-total</div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">-</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ totalTravelCosts }}</div>
               <div style="flex: 1;"></div>
             </div>
           </b-card>

           <!-- 4. Other direct costs Table -->
           <b-card no-body class="excel-table mb-4" style="border: 1px solid black; border-radius: 0;" v-if="!formItem.esDescuento && !formItem.consultoriaPorHoras">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">4. Other direct costs (attributable directly to the project)</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ totalOtherDirectCosts }} €</div>
             </div>
             <!-- Software -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Software</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtySoftware" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateSoftware" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtySoftware) || 0) * (Number(formItem.rateSoftware) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentSoftware" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Reprography and courier -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Reprography and courier</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtyReprografia" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateReprografia" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyReprografia) || 0) * (Number(formItem.rateReprografia) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentReprografia" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Communications -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Communications</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtyComunicaciones" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateComunicaciones" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyComunicaciones) || 0) * (Number(formItem.rateComunicaciones) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentComunicaciones" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Others -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Others</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.qtyOtros" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-form-input type="number" step="any" size="sm" v-model="formItem.rateOtros" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ parseFloat(((Number(formItem.qtyOtros) || 0) * (Number(formItem.rateOtros) || 0)).toFixed(2)) }}</div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentOtros" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Sub-total Other Direct Costs -->
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Sub-total</div>
               <div style="flex: 0 0 20%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ totalOtherDirectCosts }}</div>
               <div style="flex: 1;"></div>
             </div>
           </b-card>

           <!-- 5. Mark-up Table -->
           <b-card no-body class="excel-table mb-4" style="border: 1px solid black; border-radius: 0;" v-if="!formItem.esDescuento && !formItem.consultoriaPorHoras">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">5. Mark-up</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ totalMarkup }} €</div>
             </div>
             <!-- Top 3 individual margins -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Profit Travel expenses (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupTravel" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ calcProfitTravel }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupTravel" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Profit Subcontract (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupSubcontract" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ calcProfitSubcontract }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupSubcontract" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff; border-bottom: 2px solid black;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Profit Others direct cost (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #deebf7;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupOtherDirect" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ calcProfitOtherDirect }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupOtherDirect" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             
             <!-- Personnel & indirect group -->
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px; position: relative;">
                 
                 Contingencies (%)
               </div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #b7dee8;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupContingencies" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupContingencies" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Negotiation Margin (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #b7dee8;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupNegotiation" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupNegotiation" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Servicio URGENTE (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #b7dee8;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupUrgent" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupUrgent" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Commission / Sponsorship (%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; background-color: #b7dee8;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupCommission" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1; background-color: #deebf7;"><b-form-input size="sm" v-model="formItem.commentMarkupCommission" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <div class="excel-row" style="background-color: #ffffff;">
               <div style="flex: 0 0 25%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Profit horas DAT(%)</div>
               <div style="flex: 0 0 15%; padding: 4px 12px; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"><b-input-group append="%"><b-form-input type="number" step="0.01" size="sm" v-model="formItem.markupDAT" @input="updateTotals" class="border-0 bg-transparent rounded-0 shadow-none text-right"></b-form-input></b-input-group></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;"></div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1;"><b-form-input size="sm" v-model="formItem.commentMarkupDAT" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
             </div>
             <!-- Sub-total Mark-up (%) -->
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 2px solid black; border-bottom: 2px solid black;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Sub-TOTAL Mark-up (%)</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 4px 12px; text-align: right;">{{ subTotalMarkupPercent.toFixed(1) }}%</div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ calcSubTotalMarkup }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1;"></div>
             </div>             
             <!-- Sub-total Final Row -->
             <div class="excel-row font-weight-bold" style="background-color: #ffffff;">
               <div style="flex: 0 0 40%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px; text-align: center;">Sub-total</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black;"></div>
               <div style="flex: 0 0 10%; padding: 4px 12px; border-right: 1px solid black; text-align: center;">{{ calcSubTotalMarkup }}</div>
               <div style="flex: 0 0 10%; border-right: 1px solid black; padding: 0;"></div>
               <div style="flex: 1;"></div>
             </div>
           </b-card>

           <!-- 6. Selling Price Table -->
           <div class="excel-table mb-4" style="border: 2px solid black;">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">6. Selling price (€)</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ formItem.importeItem }} €</div>
             </div>
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Selling-price (€)</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #ffffff;">{{ formItem.importeItem }}</div>
             </div>
           </div>

           <!-- 7. Quotation price Table -->
           <div class="excel-table mb-4" style="border: 2px solid black;">
             <div class="excel-row font-weight-bold" style="background-color: #e2efda;">
               <div style="flex: 0 0 70%; padding: 4px 12px; border-right: 1px solid black;">7. Quotation price (Currency 2)</div>
               <div style="flex: 1; padding: 4px 12px; text-align: right; background-color: #d9d9d9;">{{ quotationPrice }} €</div>
             </div>
             <div class="excel-row" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 35%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Currency exchange (EUR/Currency 2)</div>
               <div style="flex: 0 0 15%; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="0.0001" size="sm" v-model="formItem.currencyExchange" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
               <div style="flex: 1; padding: 4px 12px; text-align: left; background-color: #b7dee8;">Conservative value including volatility or hedge</div>
             </div>
             <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
               <div style="flex: 0 0 50%; padding: 4px 12px; border-right: 1px solid black; padding-left: 24px;">Selling-price (Currency 2)</div>
               <div style="flex: 0 0 20%; padding: 4px 12px; border-right: 1px solid black; text-align: center; background-color: #e2efda;">{{ quotationPrice }}</div>
               <div style="flex: 1;"></div>
             </div>
           </div>

           <!-- Additional standard item fields removed as they are redundant -->
          <div class="d-flex justify-content-end mt-3">
             <b-button variant="secondary" @click="$refs['item-modal'].hide()" class="mr-2">Cancelar</b-button>
             <b-button variant="success" type="submit" :disabled="isReadOnly">Guardar Item</b-button>
          </div>
       </b-form>
    </b-modal>

    <!-- Modal para Desglose de Actividades (already exists, adding viajes-modal after it) -->
    <!-- ... existing activities-modal ... -->

    <!-- Modal para Desglose de Viajes -->
    <b-modal ref="viajes-modal" title="Desglose de Viajes y Estancias" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="excel-table" style="border: 1px solid black;">
        <!-- Header: Origin/Destination -->
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; font-weight: bold; background-color: #ffffff;">Oficina ORIGEN (ITEM)</div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input size="sm" v-model="travelData.origen" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
        </div>
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; font-weight: bold; background-color: #ffffff;">DESTINO SERVICIO (Location service ITEM)</div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input size="sm" v-model="travelData.destino" class="border-0 bg-transparent rounded-0 shadow-none"></b-form-input></div>
        </div>

        <!-- TRAVEL (hours) Header -->
        <div class="excel-row" style="background-color: #e2efda; font-weight: bold; border-top: 1px solid black;">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black;">TRAVEL (hours)</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">LS / Principal</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">Senior</div>
          <div style="flex: 1; text-align: center;">Junior</div>
        </div>

        <!-- Travel Time Row -->
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; background-color: #ffffff;">Travel time (hours; one way)</div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="0.01" size="sm" v-model="travelData.oneWayHours.principal" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="0.01" size="sm" v-model="travelData.oneWayHours.senior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input type="number" step="0.01" size="sm" v-model="travelData.oneWayHours.junior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
        </div>

        <!-- Return Trips Row -->
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; background-color: #ffffff;">RETURN TRIPS</div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.returnTrips.principal" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.returnTrips.senior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.returnTrips.junior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
        </div>

        <!-- TOTAL (TRAVEL hours) -->
        <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black;">TOTAL (hours)</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">{{ travelTotalHours('principal') }}</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">{{ travelTotalHours('senior') }}</div>
          <div style="flex: 1; text-align: center;">{{ travelTotalHours('junior') }}</div>
        </div>

        <!-- VISITS (days) Header -->
        <div class="excel-row" style="background-color: #ffffff; font-weight: bold; border-top: 2px solid black;">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black;">VISITS (days)</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;"></div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;"></div>
          <div style="flex: 1; text-align: center;"></div>
        </div>

        <!-- Working Days -->
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; background-color: #ffffff;">Working days</div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.workingDays.principal" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.workingDays.senior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.workingDays.junior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
        </div>

        <!-- Non-working Days -->
        <div class="excel-row">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black; background-color: #ffffff;">Non-working days (ex. Weekends..)</div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.nonWorkingDays.principal" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.nonWorkingDays.senior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; background-color: #b7dee8;"><b-form-input type="number" step="1" size="sm" v-model="travelData.nonWorkingDays.junior" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
        </div>

        <!-- TOTAL (days) -->
        <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 1px solid black;">
          <div style="flex: 0 0 40%; padding: 4px 8px; border-right: 1px solid black;">TOTAL (days)</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">{{ travelTotalDays('principal') }}</div>
          <div style="flex: 1; text-align: center; border-right: 1px solid black;">{{ travelTotalDays('senior') }}</div>
          <div style="flex: 1; text-align: center;">{{ travelTotalDays('junior') }}</div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" @click="$refs['viajes-modal'].hide()" class="mr-2">Cancelar</b-button>
        <b-button variant="success" @click="cerrarDesgloseViajes">Cerrar y Actualizar</b-button>
      </div>
    </b-modal>

    <!-- Modal para Desglose de Actividades -->
    <b-modal ref="actividades-modal" title="Desglose de Horas por Actividad" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="d-flex">
        <div class="excel-table flex-grow-1" style="border: 1px solid black;">
          <!-- Header -->
          <div class="excel-row font-weight-bold" style="background-color: #e2efda; border-bottom: 2px solid black;">
            <div style="flex: 0 0 35%; padding: 8px; border-right: 1px solid black; text-align: center;">Activity</div>
            <div style="flex: 1; padding: 8px; border-right: 1px solid black; text-align: center;">Principal / LS</div>
            <div style="flex: 1; padding: 8px; border-right: 1px solid black; text-align: center;">Senior</div>
            <div style="flex: 1; padding: 8px; border-right: 1px solid black; text-align: center;">Junior</div>
            <div style="flex: 1; padding: 8px; border-right: 1px solid black; text-align: center;">Trainee</div>
            <div style="flex: 1; padding: 8px; text-align: center;">Delineante</div>
          </div>
        
        <!-- Rows for each activity -->
        <div v-for="(act, idx) in activityGrid" :key="idx" class="excel-row">
          <div style="flex: 0 0 35%; padding: 4px 8px; border-right: 1px solid black; background-color: #ffffff;">{{ act.name }}</div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.5" size="sm" v-model="act.principal" @input="recalcPMHours" :disabled="idx === 0" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.5" size="sm" v-model="act.senior" @input="recalcPMHours" :disabled="idx === 0" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.5" size="sm" v-model="act.junior" @input="recalcPMHours" :disabled="idx === 0" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; border-right: 1px solid black; background-color: #f2f2f2;"><b-form-input type="number" step="0.5" size="sm" v-model="act.trainee" @input="recalcPMHours" :disabled="idx === 0" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
          <div style="flex: 1; background-color: #f2f2f2;"><b-form-input type="number" step="0.5" size="sm" v-model="act.delineante" @input="recalcPMHours" :disabled="idx === 0" class="border-0 bg-transparent rounded-0 shadow-none text-center"></b-form-input></div>
        </div>

        <!-- Totals -->
        <div class="excel-row font-weight-bold" style="background-color: #ffffff; border-top: 2px solid black;">
          <div style="flex: 0 0 35%; padding: 4px 8px; border-right: 1px solid black;">Total horas</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ colTotal('principal') }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ colTotal('senior') }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ colTotal('junior') }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ colTotal('trainee') }}</div>
          <div style="flex: 1; text-align: center; padding: 4px;">{{ colTotal('delineante') }}</div>
        </div>
        <div class="excel-row" style="background-color: #ffffff;">
          <div style="flex: 0 0 35%; padding: 4px 8px; border-right: 1px solid black;">Total días</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ (colTotal('principal')/8).toFixed(2) }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ (colTotal('senior')/8).toFixed(2) }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ (colTotal('junior')/8).toFixed(2) }}</div>
          <div style="flex: 1; border-right: 1px solid black; text-align: center; padding: 4px;">{{ (colTotal('trainee')/8).toFixed(2) }}</div>
          <div style="flex: 1; text-align: center; padding: 4px;">{{ (colTotal('delineante')/8).toFixed(2) }}</div>
        </div>
      </div>
      
      <div class="p-3 ml-3" style="width: 200px; border: 2px solid black; height: fit-content; text-align: center;">
        <div class="font-weight-bold mb-2">% PM</div>
        <div style="background-color: #b7dee8; padding: 5px; border: 1px solid black; font-weight: bold;">
          <b-input-group append="%">
            <b-form-input type="number" step="0.01" size="sm" v-model="formItem.percentPM" @input="recalcPMHours" class="text-center font-weight-bold"></b-form-input>
          </b-input-group>
        </div>
      </div>
    </div>
    
    <div class="d-flex justify-content-end mt-3">
      <b-button variant="success" @click="cerrarDesgloseActividades">Aceptar y Sincronizar Horas</b-button>
    </div>
    </b-modal>

    <!-- info modal cliente-->
    <b-modal :id="infoModalCliente.id" :title="infoModalCliente.title" ok-only size="lg" @hidden="cargarClientes">
      <Clientes ref="Cliente" :is-selection-mode="true" @client-selected="handleClientSelected" />
    </b-modal>

    <!-- Modal Gestión Categorías Precios -->
    <b-modal id="modal-precio-hora" title="Gestión de Categorías de Precios por Sector" ok-only size="lg" @hidden="cargarCategoriasPrecios">
      <PrecioHoraCategoriaSectorComponent />
    </b-modal>
    <!-- Modal Gestión Gastos de Viaje -->
    <b-modal id="modal-travel-expenses" title="Travel Expenses" ok-only size="lg" @hidden="cargarTravelExpenses">
      <TravelExpenseMaintenanceComponent :default-type="expenseTypeForModal" />
    </b-modal>
    <!-- Modal Gestión Condiciones de Pago -->
    <b-modal id="modal-condiciones-pago" title="Gestión de Condiciones de Pago" ok-only size="lg" @hidden="cargarCondicionesPago">
      <CondicionesPagoMaintenanceComponent tipo="PAGO" />
    </b-modal>
    <!-- Modal Mantenimiento Condiciones de Cobro -->
    <b-modal id="modal-condiciones-cobro" title="Gestionar Condiciones de Cobro" size="lg" hide-footer @hidden="cargarCondicionesCobro">
      <CondicionesPagoMaintenanceComponent tipo="COBRO" />
    </b-modal>
    <!-- Modal Chat Oferta -->
    <b-modal
      id="modal-chat-oferta"
      size="xl"
      hide-header
      title="Chat de la Oferta"
      ok-only
      ok-title="Cerrar Chat"
    >
      <chat-oferta
        v-if="oferta && oferta.id"
        :oferta-id="String(oferta.id)"
        :codigo="oferta.numeroOferta"
        :username="currentUserName"
      />
    </b-modal>

    <!-- Modal 1: Seleccionar Oferta para Clonar -->
    <b-modal id="modal-seleccionar-oferta-clon" title="Seleccionar Oferta de origen" size="lg" hide-footer>
      <div class="p-2">
        <b-input-group class="mb-3">
          <b-form-input v-model="searchOfertaClon" placeholder="Buscar por número o nombre de oferta..." @keyup.enter="buscarOfertasClon"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="buscarOfertasClon">
              <i class="fas fa-search"></i> Buscar
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <b-table
          v-if="listaOfertasClon.length > 0"
          :items="listaOfertasClon"
          :fields="[
            { key: 'numeroOferta', label: 'Nº Oferta', sortable: true },
            { key: 'nombreOferta', label: 'Nombre Oferta', sortable: true },
            { key: 'accion', label: 'Seleccionar', thStyle: { width: '100px' } }
          ]"
          hover
          small
          responsive
          style="max-height: 650px; overflow-y: auto;"
        >
          <template #cell(accion)="row">
            <b-button size="sm" variant="outline-success" @click="seleccionarOfertaParaClon(row.item)">
              <i class="fas fa-check"></i>
            </b-button>
          </template>
        </b-table>
        
        <!-- Paginación -->
        <div v-if="totalRowsClon > perPageClon" class="mt-3 d-flex justify-content-center">
          <b-pagination
            v-model="currentPageClon"
            :total-rows="totalRowsClon"
            :per-page="perPageClon"
            @change="cambiarPaginaClon"
            size="sm"
            align="center"
          ></b-pagination>
        </div>

        <div v-if="listaOfertasClon.length === 0" class="text-center p-4 text-muted">
          No se han encontrado ofertas. Prueba a buscar por nombre o número.
        </div>
      </div>
    </b-modal>

    <!-- Modal 2: Seleccionar Items de la Oferta -->
    <b-modal id="modal-seleccionar-items-clon" title="Seleccionar Items para clonar" size="xl" @ok="ejecutarClonadoItems">
      <div class="p-2" v-if="ofertaSeleccionadaClon">
        <div class="mb-3">
          <p><strong>Oferta:</strong> {{ ofertaSeleccionadaClon.numeroOferta }} - {{ ofertaSeleccionadaClon.nombreOferta }}</p>
          <p class="small text-muted">Selecciona los ítems que deseas añadir a tu oferta actual.</p>
        </div>

        <b-table
          :items="itemsOfertaClon"
          :fields="[
            { key: 'selected', label: '', thStyle: { width: '40px' } },
            { key: 'numeroItem', label: 'Item', sortable: true },
            { key: 'descripcion', label: 'Descripción', sortable: true },
            { key: 'importeItem', label: 'Importe', sortable: true }
          ]"
          hover
          small
          responsive
        >
          <template #cell(selected)="row">
            <div class="d-flex justify-content-center align-items-center" style="min-height: 32px;">
              <input type="checkbox" v-model="row.item.checkedClon" style="width: 18px; height: 18px; cursor: pointer;" />
            </div>
          </template>
          <template #cell(importeItem)="row">
            {{ getQuotationPrice(row.item).toLocaleString('es-ES', { minimumFractionDigits: 2 }) }} €
          </template>
        </b-table>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button variant="primary" @click="ok()" :disabled="!tieneItemsSeleccionadosClon">
          Clonar Seleccionados
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";
import ChatOferta from "./ChatOferta.vue";
import BarChart from './BarChart.vue';
import PieChart from './PieChart.vue';
import Clientes from "../views/Clientes.vue";
import PrecioHoraCategoriaSectorComponent from "./PrecioHoraCategoriaSectorComponent.vue";
import TravelExpenseMaintenanceComponent from "./TravelExpenseMaintenanceComponent.vue";
import CondicionesPagoMaintenanceComponent from "./CondicionesPagoMaintenanceComponent.vue";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import download from 'downloadjs';
import { 
  logoencabezadotriangulopartido, 
  logoencabezadoladoderecho_plantillaofertas 
} from "@/assets/logoBase64";
pdfMake.vfs = pdfFonts.vfs;

const TRAVEL_NOTES_TEXT = "Gastos de viaje no incluidos en la presente oferta y serán cargados a coste real. En caso de desplazamiento con vehículo propio, se facturará a 0,38€/km.";
const TRAVEL_NOTES_TEXT_EN = "Travel expenses are not included in this offer and will be charged at actual cost. In the case of travel by private vehicle, mileage will be invoiced at €0.38/km.";
const DEFAULT_NOTES = ""; 

const CONDICIONES_VENTA_URL = "https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fdekraprod-media.e-spirit.cloud%2F0246614d-1144-4d92-a4b9-a0cbcefd8806%2Fmedia%2Fcondiciones-generales-de-venta.pdf&data=05%7C02%7Csandra.monte%40dekra.com%7C9939b04a700e42ef46ac08de584600fa%7Ccf81581fcf8c405d97e334a295c8d882%7C0%7C0%7C639045254870867198%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=%2B%2FhIgRF%2FMPsc1n9T%2FiBt8XPMpicE%2FxZ%2BlYwckR8yJ9Q%3D&reserved=0";
const CONDICIONES_VENTA_URL_EN = "https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fdekraprod-media.e-spirit.cloud%2F0246614d-1144-4d92-a4b9-a0cbcefd8806%2Fmedia%2Fgeneral-terms-and-conditions-of-sale.pdf&data=05%7C02%7Ccristina.perez.crespo%40dekra.com%7C9939b04a700e42ef46ac08de584600fa%7Ccf81581fcf8c405d97e334a295c8d882%7C0%7C0%7C639045254870700251%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=wdV%2BxNkn%2BwZLhL8ZMnpeaxG6tcUt9RrI4NHw37pFu%2F4%3D&reserved=0";

const CONDICIONES_VENTA_TEXT = `Este precio no incluye IVA y es válido para las siguientes condiciones:

• Servicios a realizar durante el año en curso. Para los trabajos desarrollados a partir del año siguiente, los precios se actualizarán de acuerdo al incremento del IPC anual en España, o como mínimo un 2%.

• Los servicios solicitados con carácter urgente estarán sujetos a disponibilidad y podrán implicar la reorganización de recursos. En estos casos, se aplicará un recargo adicional sobre el importe total del presupuesto, en función del nivel de urgencia requerido.

• En caso de cancelación de los trabajos con menos de 48 horas de antelación debido a cambios en la planificación, se aplicarán costes adicionales por el tiempo improductivo generado (idle time) y por los gastos de desplazamiento ya comprometidos.

• En caso de cancelación el mismo día de la intervención, o si el servicio no pudiera ejecutarse en el lugar por causas imputables al cliente, se facturará el 100% del coste correspondiente al primer día del servicio previsto.

• La presente oferta tiene una validez de 90 días desde su fecha de emisión. Transcurrido dicho plazo, DEKRA se reserva el derecho de revisar las condiciones económicas y de servicio.

• Las Condiciones Generales de Venta aplicables a la presente oferta están disponibles en el siguiente enlace: ${CONDICIONES_VENTA_URL}`;

const CONDICIONES_VENTA_TEXT_EN = `This price does not include VAT and is valid under the following conditions:

• Services to be performed during the current calendar year. For work carried out in the following year, prices will be updated according to the annual CPI increase in Spain, or a minimum of 2%.

• Services requested on an urgent basis will be subject to availability and may require resource rescheduling. In such cases, an additional surcharge will be applied to the total amount of the quotation, depending on the level of urgency required.

• If the work is cancelled with less than 48 hours’ notice due to changes in planning, additional charges will apply for the unproductive time generated (idle time) and for any travel expenses already committed.

• In case of same day cancellation of the intervention, or if the service cannot be carried out on site due to reasons attributable to the client, 100% of the cost corresponding to the first scheduled service day will be invoiced.

• This offer is valid for 90 days from its issue date. After this period, DEKRA reserves the right to review economic and service conditions.

• The General Terms and Conditions of Sale applicable to this offer are available at the following link: ${CONDICIONES_VENTA_URL_EN}`;

export default {
  name: "OfertaDetailComponent",
  components: {
    BarChart,
    PieChart,
    Clientes,
    PrecioHoraCategoriaSectorComponent,
    TravelExpenseMaintenanceComponent,
    CondicionesPagoMaintenanceComponent,
    ChatOferta
  },
  props: ['id'],
  data() {
    return {
      tabIndex: 0,
      infoModalCliente: { id: "info-modal-cliente", title: "Nuevo cliente" },

      // Bloqueo de edición (tipo Project)
      editandoProject: false,
      empleadoEditando: "",
      nombreEmpleado: "",
      editStartAt: null,
      autoKickId: null,
      EDIT_WINDOW_MS: 25 * 60 * 1000, // 25 minutos ventana de aviso/kick
      
      oferta: { versiones: [] },
      currentVersion: null,
      editingItemIndex: -1,
      clientes: [],
      formItem: {},
      optionsTipoProyecto: [],
      optionsTipoServicio: [],
      optionsSectores: [],
      desgloseViajes: "",
      // Clonado de items
      searchOfertaClon: "",
      listaOfertasClon: [],
      totalRowsClon: 0,
      currentPageClon: 1,
      perPageClon: 10,
      ofertaSeleccionadaClon: null,
      itemsOfertaClon: [],
      chartViewMode: "TOTAL",

      travelData: {
        origen: "",
        destino: "",
        oneWayHours: { principal: 0, senior: 0, junior: 0 },
        returnTrips: { principal: 0, senior: 0, junior: 0 },
        workingDays: { principal: 0, senior: 0, junior: 0 },
        nonWorkingDays: { principal: 0, senior: 0, junior: 0 }
      },
      optionsCondicionesPago: [], 
      condicionesPagoRecords: [],
      optionsCondicionesCobro: [], 
      condicionesCobroRecords: [],
      priceCategories: [], // List of PrecioHoraCategoriaSector objects
      selectedPriceCategoryId: null,
      travelExpenses: [],
      expenseTypeForModal: "transporte", 
      empleados: [],
      contactoDekraEmail: "",
      nuevaAmpliacionNumero: "",
      includeTravelNotes: false,
      opcionalesTemplates: [],
      dragActive: false,
      isUploading: false,
      activityGrid: []
    };
  },
  watch: {
    calculatedCommercialCommission: {
      handler(newVal) {
        if (this.currentVersion && this.currentVersion.comisionComercial) {
          this.currentVersion.importeComisionComercial = newVal;
        } else if (this.currentVersion) {
          this.currentVersion.importeComisionComercial = 0;
        }
      },
      immediate: true,
    },
    clientes: {
      handler(newClientes) {
        if (this.oferta.cliente && Array.isArray(newClientes)) {
          const found = newClientes.find((cli) => cli.id === this.oferta.cliente.id);
          if (!found) {
            // This logic might be intended to keep it null if not found in list
            // but usually we just want to ensure it's the same object reference if needed
          }
        }
      },
      immediate: true,
    },
    'totalSelectedItemsPrice'(newVal) {
      if (this.currentVersion && this.currentVersion.comisionComercial) {
        // If the total crosses the threshold, we update the default percentage
        // UNLESS the user has already manually set a different value?
        // Let's just always update the default when the threshold is crossed to follow user's "7 or 10" rule.
        const oldRate = this.currentVersion.porcentajeComisionComercial;
        const newRate = newVal < 10000 ? 7 : 10;
        if (oldRate === 7 && newRate === 10) this.currentVersion.porcentajeComisionComercial = 10;
        if (oldRate === 10 && newRate === 7) this.currentVersion.porcentajeComisionComercial = 7;
      }
    },
    'currentVersion.comisionComercial'(newVal) {
      if (newVal && this.currentVersion && !this.currentVersion.porcentajeComisionComercial) {
        this.currentVersion.porcentajeComisionComercial = this.defaultCommissionRate;
      }
    },
    'currentVersion.contactoDekra': {
      async handler(newVal) {
        if (newVal && newVal.username) {
          try {
            const response = await api1.get(`/api/dekra-projects/v204/oferta/user-email/${newVal.username}`);
            this.contactoDekraEmail = response.data;
          } catch (error) {
            console.error("Error fetching user email", error);
            this.contactoDekraEmail = "";
          }
        } else {
          this.contactoDekraEmail = "";
        }
      },
      immediate: true
    },
    'currentVersion.ingles'(newVal) {
      if (this.currentVersion) {
        // Auto-update sales terms if empty or if they contain the default text of the OTHER language
        const currentText = this.currentVersion.condicionesVenta || "";
        if (!currentText.trim() || currentText === CONDICIONES_VENTA_TEXT || currentText === CONDICIONES_VENTA_TEXT_EN) {
          this.currentVersion.condicionesVenta = newVal ? CONDICIONES_VENTA_TEXT_EN : CONDICIONES_VENTA_TEXT;
        }
      }
    },
    '$route.query.openChatId'(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.openChat();
        });
      }
    },
    tabIndex(newVal, oldVal) {
      // Si cambiamos de pestaña y no es la inicialización, guardamos automáticamente
      if (oldVal !== undefined && !this.isReadOnly) {
        this.guardarVersion(true, false);
      }
    }
  },
  async mounted() {
    this.optionsTipoProyecto = this.$constants().optionsTipoProyectoEsp;
    this.optionsTipoServicio = this.$constants().optionsClaseProyectoESP;
    this.optionsSectores = this.$constants().optionsSectoresEsp;
    this.optionsCondicionesPago = this.$constants().optionsCondicionesPago;
    await this.cargarOferta();
    await this.cargarClientes();
    await this.cargarCategoriasPrecios();
    await this.cargarTravelExpenses();
    await this.cargarCondicionesPago();
    await this.cargarCondicionesCobro();
    await this.cargarEmpleados();
    await this.cargarOpcionalesTemplates();

    if (this.id !== 'nuevo') {
      await this.cargarNombreEmpleado();
      await this.tryBloquearAlEntrar();
      window.addEventListener("beforeunload", this.releaseLockBeacon);
    }

    // Listener para abrir chat desde notificaciones
    this.$root.$on('open-oferta-chat', (ofertaId) => {
      if (this.oferta && this.oferta.id == ofertaId) {
        this.openChat();
      }
    });

    // Auto-abrir si viene de query param (notificación)
    if (this.$route.query.openChatId) {
      this.$nextTick(() => {
        this.openChat();
      });
    }
  },
  beforeDestroy() {
    if (this.id !== 'nuevo') {
      this.releaseLockSimple();
    }
  },
  computed: {
    versionesOrdenadas() {
      if (!this.oferta || !this.oferta.versiones) return [];
      return [...this.oferta.versiones].sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));
    },
    standardItems() {
      if (!this.currentVersion || !this.currentVersion.items) return [];
      return this.sortedItemsForTable.filter(i => !i.opcional);
    },
    hasConsultingItems() {
      if (!this.currentVersion || !this.currentVersion.items) return false;
      return this.currentVersion.items.some(it => it.consultoriaPorHoras);
    },
    optionalItems() {
      if (!this.currentVersion || !this.currentVersion.items) return [];
      return this.sortedItemsForTable.filter(i => i.opcional);
    },
    sortedItemsForTable() {
      if (!this.currentVersion || !this.currentVersion.items) return [];
      return [...this.currentVersion.items].sort((a, b) => {
        // First by number (natural) then by ID if same number (unlikely but safe)
        const numRes = (a.numeroItem || "").localeCompare((b.numeroItem || ""), undefined, { numeric: true, sensitivity: 'base' });
        if (numRes !== 0) return numRes;
        return (Number(a.id) || 0) - (Number(b.id) || 0);
      });
    },
    condicionesPagoOptions() {
      return this.condicionesPagoRecords.map(r => ({
        value: r.nombre,
        text: r.nombre
      }));
    },
    isReadOnly() {
      // Es Solo Lectura si está bloqueado por OTRO
      return this.editandoProject && !this.isMyLock;
    },
    isMyLock() {
      if (!this.editandoProject) return false;
      const normalize = (s) => (s || "").normalize("NFD").replace(/\p{Diacritic}/gu, "").trim().toLowerCase();
      const me = normalize(this.currentUserName);
      const who = normalize(this.empleadoEditando);
      return me && who && me === who;
    },
    currentUserName() {
      return this.nombreEmpleado;
    },
    tieneItemsSeleccionadosClon() {
      return this.itemsOfertaClon.some(i => i.checkedClon);
    },
    totalPersonnelHours() {
      return Math.ceil(
             (Number(this.formItem.horasPrincipal) || 0) + 
             (Number(this.formItem.horasSenior) || 0) + 
             (Number(this.formItem.horasJunior) || 0) + 
             (Number(this.actualDelineanteHours) || 0)
      );
    },
    empleadosFiltradosMemoria() {
      const empleadosFiltrados = this.empleados.filter(
        (empleado) => empleado.idioma === "ESP" && empleado.estado
      );
      return empleadosFiltrados.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
    },
    actualDelineanteHours: {
      get() {
        const rawDelineante = Number(this.formItem.horasDelineante) || 0;
        let traineeHours = 0;
        if (this.formItem.desgloseHorasActividad) {
          try {
            const desglose = JSON.parse(this.formItem.desgloseHorasActividad);
            let tSum = 0;
            let dSum = 0;
            desglose.forEach(row => {
              tSum += (Number(row.trainee) || 0);
              dSum += (Number(row.delineante) || 0);
            });
            if (Math.abs((tSum + dSum) - rawDelineante) < 0.1) {
              traineeHours = tSum;
            } else if (tSum > 0) {
              traineeHours = tSum;
            }
          } catch (e) {
            // ignore
          }
        }
        return Math.max(0, rawDelineante - traineeHours);
      },
      set(val) {
        const value = Number(val) || 0;
        let traineeHours = 0;
        if (this.formItem.desgloseHorasActividad) {
          try {
            const desglose = JSON.parse(this.formItem.desgloseHorasActividad);
            let tSum = 0;
            desglose.forEach(row => {
              tSum += (Number(row.trainee) || 0);
            });
            traineeHours = tSum;
          } catch (e) {
            // ignore
          }
        }
        this.$set(this.formItem, 'horasDelineante', value + traineeHours);
      }
    },
    totalPersonnelCosts() {
      return Math.ceil(
             ((Number(this.formItem.horasPrincipal) || 0) * (Number(this.formItem.tarifaPrincipal) || 0)) + 
             ((Number(this.formItem.horasSenior) || 0) * (Number(this.formItem.tarifaSenior) || 0)) + 
             ((Number(this.formItem.horasJunior) || 0) * (Number(this.formItem.tarifaJunior) || 0)) + 
             (this.actualDelineanteHours * (Number(this.formItem.tarifaDelineante) || 0))
      );
    },
    transportExpenseOptions() {
      const opts = [{ value: null, text: "-- Seleccione --" }];
      if (this.travelExpenses) {
        this.travelExpenses.filter(e => !e.type || e.type === 'transporte').forEach(e => {
          opts.push({ value: e.description, text: e.description });
        });
      }
      return opts;
    },
    hotelExpenseOptions() {
      const opts = [{ value: null, text: "-- Seleccione --" }];
      if (this.travelExpenses) {
        this.travelExpenses.filter(e => e.type === 'hotel').forEach(e => {
          opts.push({ value: e.description, text: e.description });
        });
      }
      return opts;
    },
    totalSubcontractsCosts() {
      return Math.ceil(
        ((Number(this.formItem.qtyThirdParty) || 0) * (Number(this.formItem.priceThirdParty) || 0)) +
        ((Number(this.formItem.qtyTranslation) || 0) * (Number(this.formItem.priceTranslation) || 0)) +
        ((Number(this.formItem.qtyOtherSubcalc) || 0) * (Number(this.formItem.priceOtherSubcalc) || 0))
      );
    },
    totalTravelCosts() {
      return Math.ceil(
        ((Number(this.formItem.qtyTravelLS) || 0) * (Number(this.formItem.rateTravelLS) || 0)) +
        ((Number(this.formItem.qtyTravelSenior) || 0) * (Number(this.formItem.rateTravelSenior) || 0)) +
        ((Number(this.formItem.qtyTravelJunior) || 0) * (Number(this.formItem.rateTravelJunior) || 0)) +
        ((Number(this.formItem.qtyFlight) || 0) * (Number(this.formItem.rateFlight) || 0)) +
        ((Number(this.formItem.qtyCarRental) || 0) * (Number(this.formItem.rateCarRental) || 0)) +
        (Number(this.formItem.priceFuel) || 0) +
        ((Number(this.formItem.qtyKmOwnCar) || 0) * (Number(this.formItem.rateKmOwnCar) || 0)) +
        ((Number(this.formItem.qtyTolls) || 0) * (Number(this.formItem.rateTolls) || 0)) +
        ((Number(this.formItem.qtyTaxi) || 0) * (Number(this.formItem.rateTaxi) || 0)) +
        ((Number(this.formItem.qtyHotel) || 0) * (Number(this.formItem.rateHotel) || 0)) +
        ((Number(this.formItem.qtyLivingAllowances) || 0) * (Number(this.formItem.rateLivingAllowances) || 0)) +
        (Number(this.formItem.priceVisa) || 0)
      );
    },
    totalOtherDirectCosts() {
      return Math.ceil(
        ((Number(this.formItem.qtySoftware) || 0) * (Number(this.formItem.rateSoftware) || 0)) +
        ((Number(this.formItem.qtyReprografia) || 0) * (Number(this.formItem.rateReprografia) || 0)) +
        ((Number(this.formItem.qtyComunicaciones) || 0) * (Number(this.formItem.rateComunicaciones) || 0)) +
        ((Number(this.formItem.qtyOtros) || 0) * (Number(this.formItem.rateOtros) || 0))
      );
    },
    calcProfitTravel() {
       const pct = (Number(this.formItem.markupTravel) || 0) / 100;
       return pct >= 1 ? 0 : Math.ceil((this.totalTravelCosts / (1 - pct)) - this.totalTravelCosts);
    },
    calcProfitSubcontract() {
       const pct = (Number(this.formItem.markupSubcontract) || 0) / 100;
       return pct >= 1 ? 0 : Math.ceil((this.totalSubcontractsCosts / (1 - pct)) - this.totalSubcontractsCosts);
    },
    calcProfitOtherDirect() {
       const pct = (Number(this.formItem.markupOtherDirect) || 0) / 100;
       return pct >= 1 ? 0 : Math.ceil((this.totalOtherDirectCosts / (1 - pct)) - this.totalOtherDirectCosts);
    },
    subTotalMarkupPercent() {
       return (Number(this.formItem.markupContingencies) || 0) +
              (Number(this.formItem.markupNegotiation) || 0) +
              (Number(this.formItem.markupUrgent) || 0) +
              (Number(this.formItem.markupCommission) || 0) +
              (Number(this.formItem.markupDAT) || 0);
    },
    calcSubTotalMarkup() {
       const pct = this.subTotalMarkupPercent / 100;
       return pct >= 1 ? 0 : Math.ceil((this.totalPersonnelCosts / (1 - pct)) - this.totalPersonnelCosts);
    },
    totalMarkup() {
       return this.calcProfitTravel + this.calcProfitSubcontract + this.calcProfitOtherDirect + this.calcSubTotalMarkup;
    },
    quotationPrice() {
       let price = this.formItem.importeItem;
       if (this.formItem.esDescuento) {
          const subtotal = this.currentVersion.items
            .filter(i => i.id !== this.formItem.id && i.seleccionado && !i.esDescuento && !i.opcional)
            .reduce((sum, item) => {
               const localPrice = (item.importeItem || 0) * (1 - (item.porcentajeDescuento || 0) / 100);
               return sum + localPrice;
            }, 0);
          
          const discount = subtotal * ((this.formItem.porcentajeDescuento || 0) / 100);
          price = -Math.round(discount * 100) / 100;
       } else {
          // Apply local discount for display
          price = price * (1 - (this.formItem.porcentajeDescuento || 0) / 100);
       }
       const exchange = Number(this.formItem.currencyExchange) || 1;
       const val = price * exchange;
       
       // Si es consultoría por horas, no redondeamos a 50
       if (this.formItem.consultoriaPorHoras) {
         return Math.round(val * 100) / 100;
       }
       
       // Final rounded price for client visibility: [0-24] -> 00, [25-74] -> 50, [75-99] -> 100
       return Math.round(val / 50) * 50;
    },
    percentPM() {
      if (!this.activityGrid || this.activityGrid.length === 0) return 0;
      const pmRow = this.activityGrid.find(a => a.name === "Project Manager");
      if (!pmRow) return 0;
      
      const pmHours = (Number(pmRow.principal) || 0) + (Number(pmRow.senior) || 0) + 
                      (Number(pmRow.junior) || 0) + (Number(pmRow.trainee) || 0) + 
                      (Number(pmRow.delineante) || 0);
      
      const totalHours = ['principal', 'senior', 'junior', 'trainee', 'delineante']
                        .reduce((sum, key) => sum + this.colTotal(key), 0);
      
      if (totalHours === 0) return 0;
      return Math.round((pmHours / totalHours) * 100);
    },
    // Chart Data Computation
    processedChartData() {
      const data = {
        principal: { horas: 0, dias: 0 },
        senior: { horas: 0, dias: 0 },
        junior: { horas: 0, dias: 0 },
        delineante: { horas: 0, dias: 0 },
        becario: { horas: 0, dias: 0 }
      };

      if (!this.currentVersion || !this.currentVersion.items) return data;

      let itemsToProcess = [];
      if (this.chartViewMode === 'TOTAL') {
        itemsToProcess = this.currentVersion.items;
      } else {
        const item = this.currentVersion.items.find(i => i.numeroItem === this.chartViewMode);
        if (item) itemsToProcess = [item];
      }

      itemsToProcess.forEach(item => {
        data.principal.horas += (item.horasPrincipal || 0);
        data.senior.horas += (item.horasSenior || 0);
        data.junior.horas += (item.horasJunior || 0);
        
        let rawDelineante = item.horasDelineante || 0;
        let traineeHours = 0;
        let delineanteHours = rawDelineante;
        
        if (item.desgloseHorasActividad) {
           try {
               let desglose = JSON.parse(item.desgloseHorasActividad);
               let tSum = 0;
               let dSum = 0;
               desglose.forEach(row => {
                   tSum += (Number(row.trainee) || 0);
                   dSum += (Number(row.delineante) || 0);
               });
               if (Math.abs((tSum + dSum) - rawDelineante) < 0.1) {
                   traineeHours = tSum;
                   delineanteHours = dSum;
               }
           } catch(e) {
               // ignore
            }
         }
        data.becario.horas += traineeHours;
        data.delineante.horas += delineanteHours;
      });
      
      // Calculate days (hours / 8)
      Object.keys(data).forEach(k => {
        data[k].dias = Math.round((data[k].horas / 8) * 10) / 10;
      });

      return data;
    },
    itemFields() {
      const fields = [
        { key: 'orden', label: 'Orden', tdClass: 'text-center align-middle', thClass: 'text-center', thStyle: { width: '80px' } },
        { key: 'seleccionado', label: 'Aceptado', tdClass: 'text-center align-middle', thClass: 'text-center', thStyle: { width: '80px' } },
        { key: 'numeroItem', label: 'Item' },
        { key: 'descripcion', label: 'Descripción' },
        { key: 'tipoProyecto', label: 'Tipo Proyecto' },
        { key: 'tipoServicio', label: 'Tipo Servicio' },
        { key: 'horasPrincipal', label: 'LS/Principal' },
        { key: 'horasSenior', label: 'Senior' },
        { key: 'horasJunior', label: 'Junior' },
        { key: 'horasDelineante', label: 'Deliniante/Trainee' }
      ];

      if (this.currentVersion && this.currentVersion.comisionComercial) {
        fields.push({ key: "importeItem", label: "Subtotal" });
        fields.push({ key: "comision", label: "Comisión" });
        fields.push({ key: "totalConComision", label: "Total" });
      } else {
        fields.push({ key: "importeItem", label: "Importe" });
      }

      fields.push({ key: "accion", label: "", thStyle: { width: '80px' }, tdClass: 'text-nowrap align-middle' });
      return fields;
    },
    totalSelectedItemsPrice() {
      if (!this.currentVersion || !this.currentVersion.items) return 0;
      let sum = 0;
      this.currentVersion.items.forEach(item => {
        if (!item.seleccionado || item.esDescuento || item.opcional) return;
        const exchangeRate = Number(item.currencyExchange) || 1;
        let basePrice = 0;
        if (item.consultoriaPorHoras) {
          basePrice = Math.round((item.importeItem || 0) * exchangeRate * 100) / 100;
        } else {
          basePrice = Math.round(((item.importeItem || 0) * exchangeRate) / 50) * 50;
        }
        sum += basePrice;
      });
      return sum;
    },
    totalStandardItemsCalculado() {
      if (!this.currentVersion || !this.currentVersion.items) return 0;
      const commissionTotal = this.calculatedCommercialCommission;
      const subtotalBase = this.totalSelectedItemsPrice;
      
      let itemsTotal = 0;
      const selectedItems = this.currentVersion.items.filter(it => it.seleccionado && !it.esDescuento && !it.opcional);
      
      selectedItems.forEach(item => {
        const base = this.getQuotationPrice(item);
        let comm = 0;
        if (subtotalBase > 0) {
          const weight = base / subtotalBase;
          comm = Math.round(weight * commissionTotal * 100) / 100;
        }
        let grossItem = 0;
        if (item.consultoriaPorHoras) {
          grossItem = Math.round((base + comm) * 100) / 100;
        } else {
          grossItem = Math.round((base + comm) / 50) * 50;
        }
        
        const localDiscountPct = (Number(item.porcentajeDescuento) || 0) / 100;
        const afterLocalDiscount = grossItem * (1 - localDiscountPct);
        itemsTotal += afterLocalDiscount;
      });

      const discountItems = this.currentVersion.items.filter(it => it.seleccionado && it.esDescuento && !it.opcional);
      discountItems.forEach(item => {
        itemsTotal += this.getQuotationPrice(item);
      });

      return itemsTotal;
    },
    totalCalculado() {
      if (!this.currentVersion || !this.currentVersion.items) return 0;
      
      const standardTotal = this.totalStandardItemsCalculado;

      // Add optional items (independent, no global discount, already included their local discount in getQuotationPrice)
      const optionalTotal = this.currentVersion.items
        .filter(it => it.seleccionado && it.opcional)
        .reduce((sum, it) => sum + this.getQuotationPrice(it), 0);

      return standardTotal + optionalTotal;
    },
    calculatedCommercialCommission() {
      if (!this.currentVersion || !this.currentVersion.comisionComercial) return 0;
      
      const total = this.totalSelectedItemsPrice;
      if (total <= 0) return 0;
      const rate = (Number(this.currentVersion.porcentajeComisionComercial) || 0) / 100;
      return Math.round(total * rate * 100) / 100;
    },
    defaultCommissionRate() {
      const total = this.totalSelectedItemsPrice;
      return total < 10000 ? 7 : 10;
    },
    barChartData() {
      const pData = this.processedChartData;
      return {
        labels: ['LS / Principal', 'Senior', 'Junior', 'Deliniante', 'Becario'],
        datasets: [
          {
            backgroundColor: ['#4b82c3', '#c64b4b', '#9bbb59', '#8064a2', '#4bacc6'],
            data: [pData.principal.horas, pData.senior.horas, pData.junior.horas, pData.delineante.horas, pData.becario.horas]
          }
        ]
      };
    },
    barChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          datalabels: {
            color: (context) => {
              return context.dataset.backgroundColor[context.dataIndex];
            },
            anchor: 'end',
            align: 'top',
            font: { weight: 'bold' },
            formatter: (value) => {
              return value > 0 ? value : '0';
            }
          }
        },
        scales: {
          y: { beginAtZero: true },
          x: { grid: { display: false } }
        }
      };
    },
    pieChartData() {
      const pData = this.processedChartData;
      return {
        labels: ['LS / Principal', 'Senior', 'Junior', 'Deliniante', 'Becario'],
        datasets: [
          {
            backgroundColor: ['#4b82c3', '#c64b4b', '#9bbb59', '#8064a2', '#4bacc6'],
            data: [pData.principal.horas, pData.senior.horas, pData.junior.horas, pData.delineante.horas, pData.becario.horas]
          }
        ]
      };
    },
    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          datalabels: {
            color: '#000',
            font: { size: 10 },
            formatter: (value, context) => {
              if(value == 0) return '';
              let sum = 0;
              let dataArr = context.chart.data.datasets[0].data;
              dataArr.map(data => { sum += Number(data); });
              if (sum === 0) return '';
              let percentage = (value * 100 / sum).toFixed(0) + "%";
              let label = context.chart.data.labels[context.dataIndex];
              return label + '\n' + percentage;
            },
            textAlign: 'center'
          }
        }
      };
    }
  },
  methods: {
    getQuotationPrice(item) {
       if (!item) return 0;
       
       if (item.esDescuento && this.currentVersion && this.currentVersion.items) {
          const subtotal = this.currentVersion.items
            .filter(i => i.id !== item.id && i.seleccionado && !i.esDescuento && !i.opcional)
            .reduce((sum, i) => {
               const localPrice = (i.importeItem || 0) * (1 - (i.porcentajeDescuento || 0) / 100);
               return sum + localPrice;
            }, 0);
          const discount = subtotal * ((item.porcentajeDescuento || 0) / 100);
          const price = -Math.round(discount * 100) / 100;
          const val = price * (Number(item.currencyExchange) || 1);
          return Math.round(val / 50) * 50;
       }

       const price = item.importeItem || 0;
       const exchange = Number(item.currencyExchange) || 1;
       const val = price * exchange;
       if (item.consultoriaPorHoras) {
         return Math.round(val * 100) / 100;
       }
       // Redondeo base a 50 antes de comisiones y descuentos
       return Math.round(val / 50) * 50;
    },
    getItemCommission(item) {
      if (!this.currentVersion || !this.currentVersion.comisionComercial || !item.seleccionado || item.opcional || item.esDescuento) return 0;
      const totalCommission = this.calculatedCommercialCommission;
      const totalSubtotal = this.totalSelectedItemsPrice;
      if (totalSubtotal <= 0) return 0;
      
      const itemPrice = this.getQuotationPrice(item);
      const weight = itemPrice / totalSubtotal;
      return Math.round(weight * totalCommission * 100) / 100;
    },
    getItemTotalWithCommission(item) {
      const price = this.getQuotationPrice(item);
      if (!this.currentVersion || !this.currentVersion.comisionComercial || !item.seleccionado || item.opcional || item.esDescuento) return price;
      const totalWithComm = price + this.getItemCommission(item); 
      if (item.consultoriaPorHoras) {
        return Math.round(totalWithComm * 100) / 100;
      }
      return Math.round(totalWithComm / 50) * 50;
    },
    async cargarOpcionalesTemplates() {
      try {
        const res = await api1.get("/api/dekra-projects/v204/item-opcional");
        this.opcionalesTemplates = res.data;
      } catch (err) {
        console.error("Error cargando plantillas opcionales", err);
      }
    },
    async tryBloquearAlEntrar() {
      if (this.oferta.editandoProject && !this.isMyLock) {
        this.editandoProject = true;
        this.empleadoEditando = this.oferta.empleadoEditando;
        this.warnLocked();
        return;
      }
      await this.bloquearOferta(true);
    },
    async cargarNombreEmpleado() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user?.username) return;
        const { data } = await api1.get(`/api/dekra/v204/empleado/username/${encodeURIComponent(user.username)}`);
        this.nombreEmpleado = data?.nombre || "";
      } catch (error) {
        console.error("Error al obtener el empleado:", error);
      }
    },
    async bloquearOferta(isLockAction, reason = "acquire") {
      if (!this.oferta.numeroOferta) return;
      const me = this.currentUserName;
      const payload = {
        numeroOferta: this.oferta.numeroOferta,
        editandoProject: isLockAction,
        empleadoEditando: me,
        reason: reason
      };
      try {
        const res = await api1.put("/api/dekra-projects/v204/oferta/estadoEditOferta", payload);
        this.editandoProject = res.data.editandoProject;
        this.empleadoEditando = res.data.empleadoEditando;
        if (isLockAction && this.isMyLock) {
          this.editStartAt = Date.now();
          this.scheduleAutoKick();
          if (reason === "acquire") {
            this.scheduleStrictAutoSave();
          }
        } else if (isLockAction && !this.isMyLock) {
          this.warnLocked();
        }
      } catch (err) {
        if (err.response && err.response.status === 409) {
          this.editandoProject = true;
          this.empleadoEditando = err.response.data.empleadoEditando;
          this.warnLocked();
        }
      }
    },
    warnLocked() {
      this.$bvToast.toast(`Modo LECTURA: ${this.empleadoEditando || 'alguien'} está editando esta oferta.`, {
        title: "Oferta Bloqueada",
        variant: "warning",
        solid: true,
        noAutoHide: true
      });
    },
    async releaseLockSimple() {
      if (this.isMyLock) {
        await this.bloquearOferta(false, "release");
      }
      if (this.autoKickId) clearTimeout(this.autoKickId);
      if (this.strictAutoSaveId) clearTimeout(this.strictAutoSaveId);
    },
    releaseLockBeacon() {
      if (!this.isMyLock || !this.oferta.numeroOferta) return;
      const me = this.currentUserName;
      const url = api1.defaults.baseURL + "/api/dekra-projects/v204/oferta/estadoEditOferta";
      const data = JSON.stringify({
        numeroOferta: this.oferta.numeroOferta,
        editandoProject: false,
        empleadoEditando: me,
        reason: "release"
      });
      navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
    },
    scheduleAutoKick() {
      if (this.autoKickId) clearTimeout(this.autoKickId);
      this.autoKickId = setTimeout(() => {
        if (this.isMyLock) {
          this.bloquearOferta(true, "heartbeat");
          this.scheduleAutoKick();
        }
      }, 5 * 60 * 1000);
    },
    scheduleStrictAutoSave() {
      if (this.strictAutoSaveId) clearTimeout(this.strictAutoSaveId);
      this.strictAutoSaveId = setTimeout(() => {
        if (this.isMyLock) {
          this.$bvToast.toast("Tiempo límite de sesión (30 min) alcanzado. Guardando cambios automáticamente y saliendo...", { 
            title: 'Auto-Guardado', variant: 'warning', solid: true, autoHideDelay: 6000 
          });
          this.guardarVersion(false);
        }
      }, 30 * 60 * 1000); 
    },

    toggleConsultoria() {
      // El valor ya ha sido actualizado por v-model, solo necesitamos recalcular
      this.updateTotals();
    },
    updateTotals() {
      if (this.formItem.esDescuento) {
        this.$set(this.formItem, 'importeItem', 0);
      } else if (this.formItem.consultoriaPorHoras) {
        this.$set(this.formItem, 'importeItem', Number(this.formItem.importeUnidad) || 0);
      } else {
        const total = (Number(this.totalPersonnelCosts) || 0) + 
                      (Number(this.totalSubcontractsCosts) || 0) + 
                      (Number(this.totalTravelCosts) || 0) + 
                      (Number(this.totalOtherDirectCosts) || 0) + 
                      (Number(this.totalMarkup) || 0);
        this.$set(this.formItem, 'importeItem', Math.ceil(total));
      }
    },
    agregarHito() {
      if (!this.currentVersion.hitosFacturacion) {
        this.$set(this.currentVersion, 'hitosFacturacion', []);
      }
      this.currentVersion.hitosFacturacion.push({ porcentaje: "", descripcion: "", description: "" });
    },
    eliminarHito(idx) {
      if (this.currentVersion.hitosFacturacion) {
        this.currentVersion.hitosFacturacion.splice(idx, 1);
      }
    },
    agregarHitoCobro() {
      if (!this.currentVersion.hitosCobro) {
        this.$set(this.currentVersion, 'hitosCobro', []);
      }
      this.currentVersion.hitosCobro.push({ porcentaje: "", descripcion: "" });
    },
    eliminarHitoCobro(idx) {
      if (this.currentVersion.hitosCobro) {
        this.currentVersion.hitosCobro.splice(idx, 1);
      }
    },
    modalCliente(button) {
      this.$root.$emit("bv::show::modal", this.infoModalCliente.id, button);
    },
    openChat() {
      this.$bvModal.show("modal-chat-oferta");
    },
    async cargarOferta() {
      if (this.id === 'nuevo') {
        this.oferta = {
          numeroOferta: "",
          nombreOferta: "",
          estado: "Abierta",
          cliente: null,
          sector: "",
          ciudad: "",
          pais: "",
          contactoOferta: "",
          emailContacto: "",
          alcance: "",
          anyo: "",
          versiones: []
        };
        this.currentVersion = {
          revisionOferta: "R0",
          motivoRevision: "Emisión inicial",
          descripcion: "",
          ganada: false,
          condicionesPago: "",
          hitosJson: "",
          hitosFacturacion: [],
          items: [],
          direccionClienteMemoria: "",
          cpClienteMemoria: "",
          poblacionClienteMemoria: "",
          paisClienteMemoria: "",
          emailContactoMemoria: "",
          notasOferta: "",
          ingles: false
        };
        this.includeTravelNotes = false;
        return;
      }

      try {
        const response = await api1.get(`/api/dekra-projects/v204/oferta/${this.id}`);
        this.oferta = response.data;
        this.editandoProject = this.oferta.editandoProject;
        this.empleadoEditando = this.oferta.empleadoEditando;
        if (this.oferta.versiones && this.oferta.versiones.length > 0) {
          // Sort by ID to ensure we pick the truly last version
          const sorted = [...this.oferta.versiones].sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));
          this.seleccionarVersion(sorted[sorted.length - 1]);
        } else {
          // Si la oferta no tiene versiones (creada con el modal antiguo)
          this.currentVersion = {
            revisionOferta: "R0",
            motivoRevision: "Emisión inicial",
            descripcion: "",
            ganada: false,
            items: [],
            ingles: false
          };
        }
      } catch (error) {
        console.error("Error loading oferta", error);
      }
    },
    async cargarCondicionesPago() {
      try {
        const { data } = await api1.get("/api/dekra-projects/v204/condiciones-pago?tipo=PAGO");
        this.condicionesPagoRecords = data;
        this.optionsCondicionesPago = [
          { value: "", text: "Seleccione..." },
          ...data.map(r => ({ value: r.nombre, text: r.nombre }))
        ];
      } catch (error) {
        console.error("Error al cargar condiciones de pago:", error);
      }
    },
    async cargarCondicionesCobro() {
      try {
        const { data } = await api1.get("/api/dekra-projects/v204/condiciones-pago?tipo=COBRO");
        this.condicionesCobroRecords = data;
        this.optionsCondicionesCobro = [
          { value: "", text: "Seleccione..." },
          ...data.map(r => ({ value: r.nombre, text: r.nombre }))
        ];
      } catch (error) {
        console.error("Error al cargar condiciones de cobro:", error);
      }
    },
    actualizarHitos(nombre) {
      if (!nombre) {
        this.$set(this.currentVersion, 'hitosFacturacion', []);
        return;
      }
      const record = this.condicionesPagoRecords.find(r => r.nombre === nombre);
      if (record && record.hitos && record.hitos.length > 0) {
        // Clonamos para evitar referencias reactivas al registro original
        const nuevosHitos = JSON.parse(JSON.stringify(record.hitos));
        this.$set(this.currentVersion, 'hitosFacturacion', nuevosHitos);
      }
    },
    actualizarHitosCobro(nombre) {
      if (!nombre) {
        this.$set(this.currentVersion, 'hitosCobro', []);
        return;
      }
      const record = this.condicionesCobroRecords.find(r => r.nombre === nombre);
      if (record && record.hitos && record.hitos.length > 0) {
        // Para COBRO solo tomamos el primer hito como una única cadena
        const nuevoHito = JSON.parse(JSON.stringify(record.hitos[0]));
        this.$set(this.currentVersion, 'hitosCobro', [nuevoHito]);
      }
    },
    actualizarHitosItem(nombre) {
      if (!nombre) {
        this.$set(this.formItem, 'hitosJson', '[]');
        return;
      }
      const record = this.condicionesPagoRecords.find(r => r.nombre === nombre);
      if (record && record.hitos && record.hitos.length > 0) {
        // Clonamos todos los campos (incluyendo description en inglés)
        const nuevosHitos = JSON.parse(JSON.stringify(record.hitos)).map(h => ({
          porcentaje: h.porcentaje,
          descripcion: h.descripcion,
          description: h.description || ""
        }));
        this.$set(this.formItem, 'hitosJson', JSON.stringify(nuevosHitos));
      }
    },
    async cargarCategoriasPrecios() {
      try {
        const response = await api1.get("/api/dekra-projects/v204/precio-hora-categoria-sector");
        this.priceCategories = response.data;
      } catch (error) {
        console.error("Error loading price categories", error);
      }
    },
    async cargarTravelExpenses() {
      try {
        const { data } = await api1.get("/api/dekra-projects/v204/travel-expenses");
        this.travelExpenses = data;
      } catch (error) {
        console.error("Error al cargar gastos de viaje:", error);
      }
    },
    async cargarEmpleados() {
      try {
        const { data } = await api1.get("/api/dekra/v204/empleado");
        this.empleados = data;
      } catch (error) {
        console.error("Error al cargar empleados:", error);
      }
    },
    onTravelExpenseSelect(type, val) {
      if (!val) return;
      const expense = this.travelExpenses.find(e => e.description === val);
      if (expense) {
        if (type === 'Flight') {
          this.formItem.rateFlight = expense.price;
        } else if (type === 'CarRental') {
          this.formItem.rateCarRental = expense.price;
        } else if (type === 'Hotel') {
          this.formItem.rateHotel = expense.price;
        }
        this.updateTotals();
      }
    },
    applyPriceCategory(categoryId) {
      if (!categoryId) {
        this.formItem.precioHoraCategoriaSector = null;
        return;
      }
      const cat = this.priceCategories.find(c => c.id === categoryId);
      if (cat) {
        this.formItem.precioHoraCategoriaSector = cat;
        // Personnel rates
        this.formItem.tarifaPrincipal = cat.tarifaPrincipal;
        this.formItem.tarifaSenior = cat.tarifaSenior;
        this.formItem.tarifaJunior = cat.tarifaJunior;
        this.formItem.tarifaDelineante = cat.tarifaDelineante;
        
        // Travel rates
        this.formItem.rateTravelLS = cat.tarifaPrincipal;
        this.formItem.rateTravelSenior = cat.tarifaSenior;
        this.formItem.rateTravelJunior = cat.tarifaJunior;

        this.updateTotals();
      }
    },
    modalPrecioHora() {
      this.$bvModal.show('modal-precio-hora');
    },
    applyOpcionalTemplate(templateId) {
      if (!templateId) return;
      const found = this.opcionalesTemplates.find(t => t.id === templateId);
      if (!found) return;
      // Deep clone to avoid shared object references between items
      const tpl = JSON.parse(JSON.stringify(found));

      // Save the fields we want to keep from the current formItem
      const keepNumeroItem = this.formItem.numeroItem;

      // Copy all fields from the template, then restore what we want to keep
      const fieldsToApply = [
        'descripcion', 'description', 'tipoProyecto', 'tipoServicio',
        'importeItem', 'notasItem', 'infoFaseOferta', 'consultoriaPorHoras',
        'condicionesPago', 'hitosJson', 'porcentajeDescuento', 'esDescuento',
        // Personnel
        'horasPrincipal', 'tarifaPrincipal', 'comentarioPrincipal',
        'horasSenior', 'tarifaSenior', 'comentarioSenior',
        'horasJunior', 'tarifaJunior', 'comentarioJunior',
        'horasDelineante', 'tarifaDelineante', 'comentarioDelineante',
        'desgloseHorasActividad', 'percentPM',
        // Subcontracts
        'qtyThirdParty', 'priceThirdParty', 'commentThirdParty',
        'qtyTranslation', 'priceTranslation', 'commentTranslation',
        'qtyOtherSubcalc', 'priceOtherSubcalc', 'commentOtherSubcalc',
        // Travel
        'qtyTravelLS', 'rateTravelLS', 'commentTravelLS',
        'qtyTravelSenior', 'rateTravelSenior', 'commentTravelSenior',
        'qtyTravelJunior', 'rateTravelJunior', 'commentTravelJunior',
        'qtyFlight', 'rateFlight', 'commentFlight',
        'qtyCarRental', 'rateCarRental', 'commentCarRental',
        'priceFuel', 'commentFuel',
        'qtyKmOwnCar', 'rateKmOwnCar', 'commentKmOwnCar',
        'qtyTolls', 'rateTolls', 'commentTolls',
        'qtyTaxi', 'rateTaxi', 'commentTaxi',
        'qtyHotel', 'rateHotel', 'commentHotel',
        'qtyLivingAllowances', 'rateLivingAllowances', 'commentLivingAllowances',
        'priceVisa', 'commentVisa',
        // Other direct costs
        'qtySoftware', 'rateSoftware', 'costeSoftware', 'commentSoftware',
        'qtyReprografia', 'rateReprografia', 'costeReprografia', 'commentReprografia',
        'qtyComunicaciones', 'rateComunicaciones', 'costeComunicaciones', 'commentComunicaciones',
        'qtyOtros', 'rateOtros', 'costeOtros', 'commentOtros',
        // Markups
        'markupTravel', 'markupSubcontract', 'markupOtherDirect',
        'markupContingencies', 'markupNegotiation', 'markupUrgent',
        'markupCommission', 'markupDAT',
        'currencyExchange', 'desgloseViajes',
        'precioHoraCategoriaSector'
      ];

      fieldsToApply.forEach(field => {
        if (tpl[field] !== undefined && tpl[field] !== null) {
          this.$set(this.formItem, field, tpl[field]);
        }
      });

      // Also apply price category id for the selector
      if (tpl.precioHoraCategoriaSector) {
        this.selectedPriceCategoryId = tpl.precioHoraCategoriaSector.id;
      }

      // Restore what belongs to the item, not the template
      this.$set(this.formItem, 'numeroItem', keepNumeroItem);
      this.$set(this.formItem, 'opcional', true);
      this.$set(this.formItem, 'opcionalTemplateId', templateId);

      this.updateTotals();
    },
    recalculateItemNumber() {
      if (!this.currentVersion || !this.currentVersion.items) return;
      if (this.formItem.opcional) {
        // Changing TO optional: number = count of optional items + 1
        const optCount = this.currentVersion.items.filter(i => i.opcional && i !== this.formItem).length;
        this.$set(this.formItem, 'numeroItem', "OPC" + (optCount + 1).toString());
      } else {
        // Changing FROM optional: number = count of standard items + 1
        const stdCount = this.currentVersion.items.filter(i => !i.opcional && i !== this.formItem).length;
        this.$set(this.formItem, 'numeroItem', (stdCount + 1).toString());
      }
    },
    async cargarClientes() {
      try {
        const response = await api1.get("/api/dekra/v204/cliente");
        this.clientes = response.data;
      } catch (error) {
        console.error("Error loading clientes", error);
      }
    },
    handleClientSelected(client) {
      if (!this.oferta) this.$set(this, 'oferta', { versiones: [] });
      
      // Asegurarnos de que el cliente esté en la lista local para que el select lo muestre inmediatamente
      if (this.clientes && !this.clientes.find(c => c.id === client.id)) {
        this.clientes.push(client);
      }
      
      // IMPORTANTE: El select en OfertaDetailComponent está enlazado a OBJETOS (no IDs)
      this.$set(this.oferta, 'cliente', client);
      this.$root.$emit('bv::hide::modal', this.infoModalCliente.id);
      this.$bvToast.toast(`Cliente ${client.nombre} seleccionado`, { variant: 'success', solid: true });
    },
    seleccionarVersion(version) {
      // Ensure missing reactive fields from older versions or null DB values are present
      this.currentVersion = Object.assign({
        condicionesPago: "",
        hitosJson: "",
        condicionesPagoIndependientes: false,
        emailContactoMemoria: "",
        direccionClienteMemoria: "",
        cpClienteMemoria: "",
        poblacionClienteMemoria: "",
        paisClienteMemoria: "",
        notasOferta: version.notasOferta && version.notasOferta.trim() !== "" ? version.notasOferta : DEFAULT_NOTES
      }, version);

      const notas = this.currentVersion.notasOferta || "";
      this.includeTravelNotes = notas.includes(TRAVEL_NOTES_TEXT) || notas.includes(TRAVEL_NOTES_TEXT_EN);

      let hitos = [];
      if (this.currentVersion.hitosJson) {
        try {
            hitos = JSON.parse(this.currentVersion.hitosJson);
        } catch(e) {
            console.error("Error parsing hitosJson:", e);
        }
      }
      
      // Fallback a campos antiguos temporal por si hay ofertas antiguas con datos sin migrar
      if (hitos.length === 0) {
          if (version.porcentajeHito1 || version.descripcionHito1) hitos.push({ porcentaje: version.porcentajeHito1, descripcion: version.descripcionHito1 });
          if (version.porcentajeHito2 || version.descripcionHito2) hitos.push({ porcentaje: version.porcentajeHito2, descripcion: version.descripcionHito2 });
          if (version.porcentajeHito3 || version.descripcionHito3) hitos.push({ porcentaje: version.porcentajeHito3, descripcion: version.descripcionHito3 });
          if (version.porcentajeHito4 || version.descripcionHito4) hitos.push({ porcentaje: version.porcentajeHito4, descripcion: version.descripcionHito4 });
      }

      // Ya no aseguramos un mínimo de 3 campos, cargamos exactamente lo que haya.
      if (this.currentVersion.items) {
        this.currentVersion.items.forEach(item => {
          if (item.seleccionado === undefined) this.$set(item, 'seleccionado', true);
          if (item.esDescuento === undefined) this.$set(item, 'esDescuento', false);
          if (item.porcentajeDescuento === undefined) this.$set(item, 'porcentajeDescuento', 0);
          if (item.opcional === undefined) this.$set(item, 'opcional', false);
        });
      }

      this.$set(this.currentVersion, 'hitosFacturacion', hitos);

      let ampliaciones = [];
      if (this.currentVersion.ampliacionesJson) {
        try {
          ampliaciones = JSON.parse(this.currentVersion.ampliacionesJson);
        } catch(e) {
          console.error("Error parsing ampliacionesJson:", e);
        }
      }
      this.$set(this.currentVersion, 'ampliaciones', ampliaciones);

      let hitosCobro = [];
      if (this.currentVersion.hitosCobroJson) {
        try {
          hitosCobro = JSON.parse(this.currentVersion.hitosCobroJson);
        } catch(e) {
          console.error("Error parsing hitosCobroJson:", e);
        }
      }
      this.$set(this.currentVersion, 'hitosCobro', hitosCobro);
    },
    async guardarVersion(stayOnPage = false, showToast = true) {
        try {
            if (this.currentVersion.hitosFacturacion) {
                this.currentVersion.hitosJson = JSON.stringify(this.currentVersion.hitosFacturacion);
            }
            if (this.currentVersion.ampliaciones) {
                this.currentVersion.ampliacionesJson = JSON.stringify(this.currentVersion.ampliaciones);
            }
            if (this.currentVersion.hitosCobro) {
                this.currentVersion.hitosCobroJson = JSON.stringify(this.currentVersion.hitosCobro);
            }

            // Asegurarnos de que currentVersion está en la lista de versiones
            const index = this.oferta.versiones.findIndex(v => (v.id && v.id === this.currentVersion.id) || v.revisionOferta === this.currentVersion.revisionOferta);
            if (index !== -1) {
              // Usar splice para asegurar reactividad en Vue 2
              this.oferta.versiones.splice(index, 1, this.currentVersion);
            } else {
              this.oferta.versiones.push(this.currentVersion);
            }

            console.log("Guardando oferta con versiones:", this.oferta.versiones);

            if (this.id === 'nuevo') {
               const response = await api1.post("/api/dekra-projects/v204/oferta", this.oferta);
               this.oferta = response.data;
               this.$bvToast.toast("Oferta creada correctamente", { variant: 'success' });
            } else {
               const response = await api1.put("/api/dekra-projects/v204/oferta", this.oferta);
               this.oferta = response.data; // Actualizar con la respuesta del servidor
               if (showToast) {
                 this.$bvToast.toast("Guardado correctamente", { variant: 'success' });
               }
            }
            // Realizar acción si está ganada
            if (this.currentVersion && this.currentVersion.ganada) {
               // Ya no llamamos a confirmarGanada aquí para no bloquear el guardado general.
               // El toggle de ganada ya gestiona su propio flujo.
            }

            if (!stayOnPage) {
               this.volverAOfertas();
            } else {
               // Si nos quedamos en la página, refrescamos la currentVersion con los datos que han venido del servidor
               // para tener los IDs nuevos y no perder la reactividad.
               const updatedVersion = this.oferta.versiones.find(v => 
                  (v.id && this.currentVersion && v.id === this.currentVersion.id) || 
                  (v.revisionOferta === (this.currentVersion && this.currentVersion.revisionOferta))
               );
               if (updatedVersion) {
                  this.seleccionarVersion(updatedVersion);
               }
            }
        } catch (error) {
            console.error(error);
        }
    },
    volverAOfertas() {
      this.$router.push({ name: 'ofertas' });
    },
    async handleGanadaChange(checked) {
      if (checked) {
        if (confirm("Al marcar como ganada se creará un Proyecto real basado en los datos de esta Oferta. ¡ADVERTENCIA! Asegúrese de haber GUARDADO los cambios de la oferta antes de hacer esto. ¿Desea crear el Proyecto ahora?")) {
          try {
            await api1.post(`/api/dekra-projects/v204/oferta/version/${this.currentVersion.id}/win`);
            this.currentVersion.ganada = true;
            this.$bvToast.toast("¡Proyecto creado con éxito!", { variant: 'success' });
            this.cargarOferta();
          } catch (error) {
            console.error(error);
            let msg = "Error al crear el proyecto";
            if (error.response && error.response.data) {
                const data = error.response.data;
                msg = data.message || data.debugMessage || data.error || (typeof data === 'string' ? data : msg);
            }
            this.$bvModal.msgBoxOk(msg, {
                title: 'Error de Validación',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
            });
            this.$nextTick(() => {
                this.currentVersion.ganada = false;
            });
          }
        } else {
          // Revert if user cancels
          this.$nextTick(() => {
            this.currentVersion.ganada = false;
          });
        }
      }
    },
    async confirmarGanada() {
      // Método deprecado por handleGanadaChange
    },
    async clonarVersion() {
      try {
        const response = await api1.post(`/api/dekra-projects/v204/oferta/version/${this.currentVersion.id}/clone`);
        // The clone is just a revision, we need to attach it to the Oferta
        await api1.post(`/api/dekra-projects/v204/oferta/${this.oferta.id}/version`, response.data);
        await this.cargarOferta();
        alert("Nueva revisión creada basada en la actual");
      } catch (error) {
        console.error(error);
      }
    },
    nuevoItem() {
      this.editingItemIndex = -1;
      const nextNumber = this.standardItems ? this.standardItems.length + 1 : 1;
      this.formItem = { 
        numeroItem: nextNumber.toString(), 
        descripcion: "", 
        description: "", 
        tipoServicio: "", 
        tipoProyecto: "",
        fechaPrimeraEntrega: "",
        consultoriaPorHoras: false,
        opcional: false,
        esDescuento: false,
        porcentajeDescuento: 0,
        notasItem: "",
        infoFaseOferta: "",
        fechaVisita: "",
        percentPM: 0,
        seleccionado: true,
        horasPrincipal: 0, tarifaPrincipal: 0, comentarioPrincipal: "",
        horasSenior: 0, tarifaSenior: 0, comentarioSenior: "",
        horasJunior: 0, tarifaJunior: 0, comentarioJunior: "",
        horasDelineante: 0, tarifaDelineante: 0, comentarioDelineante: "",
        importeUnidad: 0,
        unidadPrecio: "",
        precioHoraCategoriaSector: null,
        qtyThirdParty: 1, priceThirdParty: 0, commentThirdParty: "",
        qtyTranslation: 1, priceTranslation: 0, commentTranslation: "",
        qtyOtherSubcalc: 1, priceOtherSubcalc: 0, commentOtherSubcalc: "",
        qtyTravelLS: 0, rateTravelLS: 0, commentTravelLS: "",
        qtyTravelSenior: 0, rateTravelSenior: 0, commentTravelSenior: "",
        qtyTravelJunior: 0, rateTravelJunior: 0, commentTravelJunior: "",
        qtyFlight: 0, rateFlight: 0, commentFlight: "",
        qtyCarRental: 0, rateCarRental: 0, commentCarRental: "",
        priceFuel: 0, commentFuel: "",
        qtyKmOwnCar: 0, rateKmOwnCar: 0.38, commentKmOwnCar: "",
        qtyTolls: 0, rateTolls: 1.05, commentTolls: "",
        qtyTaxi: 0, rateTaxi: 35, commentTaxi: "",
        qtyHotel: 0, rateHotel: 0, commentHotel: "",
        qtyLivingAllowances: 0, rateLivingAllowances: 50, commentLivingAllowances: "",
        priceVisa: 0, commentVisa: "",
        qtySoftware: 0, rateSoftware: 1, costeSoftware: 0, commentSoftware: "",
        qtyReprografia: 0, rateReprografia: 1, costeReprografia: 0, commentReprografia: "",
        qtyComunicaciones: 0, rateComunicaciones: 1, costeComunicaciones: 0, commentComunicaciones: "",
        qtyOtros: 0, rateOtros: 1, costeOtros: 0, commentOtros: "",
        markupTravel: 5.0,
        markupSubcontract: 30.0,
        markupOtherDirect: 5.0,
        markupContingencies: 5.0,
        markupNegotiation: 10.0,
        markupUrgent: 0.0,
        markupCommission: 0.0,
        markupDAT: 30.0,
        currencyExchange: 1.0,
        desgloseHorasActividad: "",
        desgloseViajes: ""
      };
      this.selectedPriceCategoryId = null;
      this.updateTotals();
      this.$refs['item-modal'].show();
    },
    editarItem(item) {
      // Use the real index in currentVersion.items, not the filtered-table row index
      this.editingItemIndex = this.currentVersion.items.indexOf(item);
      this.formItem = { ...item };
      this.selectedPriceCategoryId = this.formItem.precioHoraCategoriaSector ? this.formItem.precioHoraCategoriaSector.id : null;
      if (this.formItem.percentPM === undefined) this.formItem.percentPM = 0;
      if (this.formItem.consultoriaPorHoras === undefined) this.$set(this.formItem, 'consultoriaPorHoras', false);
      if (this.formItem.importeUnidad === undefined) this.$set(this.formItem, 'importeUnidad', 0);
      if (this.formItem.unidadPrecio === undefined) this.$set(this.formItem, 'unidadPrecio', '');
      if (!this.formItem.rateTravelLS) this.formItem.rateTravelLS = 0;
      if (!this.formItem.rateTravelSenior) this.formItem.rateTravelSenior = 0;
      if (!this.formItem.rateTravelJunior) this.formItem.rateTravelJunior = 0;
      if (!this.formItem.rateCarRental) this.formItem.rateCarRental = 100;
      if (!this.formItem.rateKmOwnCar) this.formItem.rateKmOwnCar = 0.38;
      if (!this.formItem.rateTolls) this.formItem.rateTolls = 1.05;
      if (!this.formItem.rateTaxi) this.formItem.rateTaxi = 35;
      if (!this.formItem.rateHotel) this.formItem.rateHotel = 150;
      if (!this.formItem.rateLivingAllowances) this.formItem.rateLivingAllowances = 50;

      if (!this.formItem.qtySoftware) this.formItem.qtySoftware = 0;
      if (!this.formItem.rateSoftware) this.formItem.rateSoftware = 1;
      if (!this.formItem.commentSoftware) this.formItem.commentSoftware = "";

      if (!this.formItem.qtyReprografia) this.formItem.qtyReprografia = 0;
      if (!this.formItem.rateReprografia) this.formItem.rateReprografia = 1;
      if (!this.formItem.commentReprografia) this.formItem.commentReprografia = "";

      if (!this.formItem.qtyComunicaciones) this.formItem.qtyComunicaciones = 0;
      if (!this.formItem.rateComunicaciones) this.formItem.rateComunicaciones = 1;
      if (!this.formItem.commentComunicaciones) this.formItem.commentComunicaciones = "";

      if (!this.formItem.qtyOtros) this.formItem.qtyOtros = 0;
      if (!this.formItem.rateOtros) this.formItem.rateOtros = 1;
      if (!this.formItem.commentOtros) this.formItem.commentOtros = "";

      if (this.formItem.markupTravel == null || this.formItem.markupTravel === '') this.formItem.markupTravel = 5.0;
      if (this.formItem.markupSubcontract == null || this.formItem.markupSubcontract === '') this.formItem.markupSubcontract = 30.0;
      if (this.formItem.markupOtherDirect == null || this.formItem.markupOtherDirect === '') this.formItem.markupOtherDirect = 5.0;
      if (this.formItem.markupContingencies == null || this.formItem.markupContingencies === '') this.formItem.markupContingencies = 5.0;
      if (this.formItem.markupNegotiation == null || this.formItem.markupNegotiation === '') this.formItem.markupNegotiation = 10.0;
      if (this.formItem.markupUrgent == null || this.formItem.markupUrgent === '') this.formItem.markupUrgent = 0.0;
      if (this.formItem.markupCommission == null || this.formItem.markupCommission === '') this.formItem.markupCommission = 0.0;
      if (this.formItem.markupDAT == null || this.formItem.markupDAT === '') this.formItem.markupDAT = 30.0;
      if (!this.formItem.currencyExchange) this.formItem.currencyExchange = 1.0;

      if (!this.formItem.desgloseHorasActividad) this.formItem.desgloseHorasActividad = "";
      if (!this.formItem.desgloseViajes) this.formItem.desgloseViajes = "";

      this.updateTotals();
      this.$refs['item-modal'].show();
    },
    eliminarItem(item) {
      if (confirm("¿Estás seguro de eliminar este ítem?")) {
        // Use the real index in currentVersion.items, not the filtered-table row index
        const realIndex = this.currentVersion.items.indexOf(item);
        if (realIndex !== -1) {
          this.currentVersion.items.splice(realIndex, 1);
        }
        this.updateTotals();
      }
    },
    moverItemArriba(index, isOpcional) {
      if (index <= 0) return;
      const list = isOpcional ? this.optionalItems : this.standardItems;
      const current = list[index];
      const above = list[index - 1];
      
      const temp = current.numeroItem;
      current.numeroItem = above.numeroItem;
      above.numeroItem = temp;
      
      this.guardarVersion(true);
    },
    moverItemAbajo(index, isOpcional) {
      const list = isOpcional ? this.optionalItems : this.standardItems;
      if (index >= list.length - 1) return;
      const current = list[index];
      const below = list[index + 1];
      
      const temp = current.numeroItem;
      current.numeroItem = below.numeroItem;
      below.numeroItem = temp;
      
      this.guardarVersion(true);
    },
    // Métodos para el clonado de items
    async abrirModalClonOferta() {
      this.searchOfertaClon = "";
      this.listaOfertasClon = [];
      this.currentPageClon = 1;
      this.totalRowsClon = 0;
      await this.cargarOfertasClon();
      this.$bvModal.show("modal-seleccionar-oferta-clon");
    },
    async buscarOfertasClon() {
      this.currentPageClon = 1; // Reiniciar a la primera página al buscar
      await this.cargarOfertasClon();
    },
    async cambiarPaginaClon(page) {
      this.currentPageClon = page;
      await this.cargarOfertasClon();
    },
    async cargarOfertasClon() {
      try {
        const response = await api1.get("/api/dekra-projects/v204/oferta/paginado", {
          params: { 
            page: this.currentPageClon - 1, 
            size: this.perPageClon, 
            text: this.searchOfertaClon, 
            showGanadas: true, 
            showNoGanadas: true 
          }
        });
        this.listaOfertasClon = response.data.content;
        this.totalRowsClon = response.data.totalElements;
      } catch (error) {
        console.error("Error al cargar ofertas para clonar:", error);
      }
    },
    async seleccionarOfertaParaClon(oferta) {
      this.ofertaSeleccionadaClon = oferta;
      this.itemsOfertaClon = [];
      try {
        // Cargamos la oferta completa para tener sus versiones e ítems
        const response = await api1.get(`/api/dekra-projects/v204/oferta/${oferta.id}`);
        const fullOferta = response.data;
        if (fullOferta.versiones && fullOferta.versiones.length > 0) {
          // Tomamos los ítems de la versión más reciente
          const sortedVersiones = [...fullOferta.versiones].sort((a, b) => b.id - a.id);
          this.itemsOfertaClon = sortedVersiones[0].items.map(i => ({
            ...i,
            checkedClon: false
          }));
        }
        this.$bvModal.hide("modal-seleccionar-oferta-clon");
        this.$bvModal.show("modal-seleccionar-items-clon");
      } catch (error) {
        console.error("Error al cargar items de la oferta:", error);
      }
    },
    ejecutarClonadoItems() {
      const itemsToClone = this.itemsOfertaClon.filter(i => i.checkedClon);
      if (itemsToClone.length === 0) return;

      // Calculamos el siguiente número de item base y opcional
      let nextNumber = 1;
      let nextOpcNumber = 1;
      if (this.currentVersion.items && this.currentVersion.items.length > 0) {
        // Números estándar
        const nums = this.currentVersion.items
          .filter(i => !i.opcional)
          .map(i => parseInt(i.numeroItem))
          .filter(n => !isNaN(n));
        if (nums.length > 0) nextNumber = Math.max(...nums) + 1;

        // Números opcionales
        const opcNums = this.currentVersion.items
          .filter(i => i.opcional)
          .map(i => {
             const val = (i.numeroItem || "").toString().replace("OPC", "");
             return parseInt(val);
          })
          .filter(n => !isNaN(n));
        if (opcNums.length > 0) nextOpcNumber = Math.max(...opcNums) + 1;
      }

      itemsToClone.forEach(sourceItem => {
        // Clonamos el objeto profundamente
        const newItem = JSON.parse(JSON.stringify(sourceItem));
        
        // Limpiamos campos de identidad
        delete newItem.id;
        delete newItem.checkedClon;
        
        // Ajustamos el número de item correlativamente
        if (newItem.opcional) {
          newItem.numeroItem = "OPC" + nextOpcNumber;
          nextOpcNumber++;
        } else {
          newItem.numeroItem = nextNumber.toString();
          nextNumber++;
        }

        this.currentVersion.items.push(newItem);
      });

      this.$bvToast.toast(`Se han clonado ${itemsToClone.length} ítems correctamente.`, { variant: 'success' });
      // Remove updateTotals() here as it updates formItem incorrectly during cloning loop
      
      if (!this.isReadOnly) {
        this.guardarVersion(true, false);
      }
    },

    abrirDesgloseActividades() {
      // Initialize grid from formItem.desgloseHorasActividad JSON
      const defaultActivities = [
        "Project Manager", "Preparation of meetings", "Meetings (KOM, follow-up, presentations...)",
        "Preparation audit / site survey / workshop", "Audit / site survey / workshop delivery",
        "Drawings", "Reports/Procedures", "Peer Review", "Others"
      ];
      
      let savedData = [];
      if (this.formItem.desgloseHorasActividad && this.formItem.desgloseHorasActividad.trim() !== "") {
        try {
          savedData = JSON.parse(this.formItem.desgloseHorasActividad);
        } catch(e) { 
          console.error("Error parsing desgloseHorasActividad", e); 
          savedData = [];
        }
      }

      this.activityGrid = defaultActivities.map(name => {
        const found = savedData.find(d => d.name === name) || {};
        return {
          name,
          principal: found.principal !== undefined ? found.principal : 0,
          senior: found.senior !== undefined ? found.senior : 0,
          junior: found.junior !== undefined ? found.junior : 0,
          trainee: found.trainee !== undefined ? found.trainee : 0,
          delineante: found.delineante !== undefined ? found.delineante : 0
        };
      });

      this.$refs['actividades-modal'].show();
    },
    colTotal(key) {
      if (!this.activityGrid) return 0;
      return this.activityGrid.reduce((sum, row) => sum + (Number(row[key]) || 0), 0);
    },
    cerrarDesgloseActividades() {
      // Sync totals back to formItem
      this.formItem.horasPrincipal = this.colTotal('principal');
      this.formItem.horasSenior = this.colTotal('senior');
      this.formItem.horasJunior = this.colTotal('junior');
      // horasDelineante stores both Delineante + Trainee combined (they share the same DB column)
      this.formItem.horasDelineante = (Number(this.colTotal('delineante')) || 0) + (Number(this.colTotal('trainee')) || 0);
      
      this.formItem.desgloseHorasActividad = JSON.stringify(this.activityGrid);
      this.updateTotals();
      this.$refs['actividades-modal'].hide();
    },
    handleFileDrop(e) {
      this.dragActive = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.uploadFile(files[i]);
        }
      }
    },
    handleFileSelect(e) {
      const files = e.target.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.uploadFile(files[i]);
        }
      }
    },
    async uploadFile(file) {
      this.isUploading = true;
      try {
        const date = new Date().toLocaleDateString().replaceAll("/", "-");
        const fileName = `${date}_${file.name}`;
        const buffer = new File([file], fileName, { type: file.type });
        
        const formData = new FormData();
        formData.append("file", buffer);
        formData.append("ruta", "oferta_documentos/" + this.oferta.numeroOferta);

        await api1.post("/api/reporting/v204/file/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // El tipo que espera el backend de reporting para la descarga es la subparte del mime o el nombre corto
        let fileType = "file";
        if (file.type) {
            if (file.type.includes("/")) {
                fileType = file.type.split("/")[1];
            } else {
                fileType = file.type;
            }
        } else if (file.name.includes(".")) {
            fileType = file.name.split(".").pop();
        }

        const newDoc = {
          nombre: fileName,
          ruta: "oferta_documentos/" + this.oferta.numeroOferta,
          tipo: fileType
        };

        if (!this.oferta.documentos) this.$set(this.oferta, 'documentos', []);
        this.oferta.documentos.push(newDoc);
        
        // Guardamos la oferta inmediatamente para que no se pierda la relación
        await this.guardarVersion(true);
        
        this.$bvToast.toast(`Archivo ${file.name} subido correctamente`, { variant: 'success', solid: true });
      } catch (error) {
        console.error("Error uploading file:", error);
        this.$bvToast.toast("Error al subir el archivo", { variant: 'danger', solid: true });
      } finally {
        this.isUploading = false;
      }
    },
    async downloadDocument(doc) {
      try {
        const formData = new FormData();
        formData.append("nombre", doc.nombre);
        formData.append("ruta", doc.ruta);
        formData.append("tipo", doc.tipo);

        const response = await api1.post("/api/reporting/v204/file/download", formData, {
          responseType: "blob",
          headers: { "Content-Type": "multipart/form-data" },
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", doc.nombre);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    removeDocument(index) {
      if (confirm("¿Estás seguro de eliminar este documento?")) {
        this.oferta.documentos.splice(index, 1);
        this.guardarVersion(true);
      }
    },
    getFileIcon(tipo) {
      const t = (tipo || "").toLowerCase();
      if (t.includes('pdf')) return 'fas fa-file-pdf text-danger';
      if (t.includes('word') || t.includes('doc')) return 'fas fa-file-word text-primary';
      if (t.includes('excel') || t.includes('sheet') || t.includes('xls')) return 'fas fa-file-excel text-success';
      if (t.includes('image') || t.includes('jpg') || t.includes('png')) return 'fas fa-file-image text-info';
      if (t.includes('msg') || t.includes('email') || t.includes('outlook')) return 'fas fa-envelope text-warning';
      return 'fas fa-file text-secondary';
    },
    recalcPMHours() {
      if (!this.activityGrid || this.activityGrid.length === 0) return;
      
      const percent = Number(this.formItem.percentPM) || 0;
      const roles = ['principal', 'senior', 'junior', 'trainee', 'delineante'];
      
      // Sum only senior and junior roles across all activities except the first one (Project Manager)
      let totalOthers = 0;
      this.activityGrid.slice(1).forEach(row => {
        ['senior', 'junior'].forEach(role => {
          totalOthers += (Number(row[role]) || 0);
        });
      });

      // Formula: CEILING(Total * percent / 100, 1) -> Round up to 1 decimal
      const result = Math.ceil((totalOthers * (percent / 100)) * 10) / 10;
      
      const pmRow = this.activityGrid[0];
      // Reset all roles for PM row
      roles.forEach(role => {
        pmRow[role] = 0;
      });
      // Assign the result ONLY to Senior
      pmRow.senior = result;
    },
    async guardarItem() {
      // Final sync of totals before saving
      this.updateTotals();
      
      if (this.editingItemIndex !== -1) {
        this.$set(this.currentVersion.items, this.editingItemIndex, { ...this.formItem });
      } else {
        this.currentVersion.items.push({ ...this.formItem });
      }
      this.$refs['item-modal'].hide();
      
      // Save to backend using the centralized method
      if (this.id !== 'nuevo') {
        this.guardarVersion(true, true);
      }
    },
    abrirDesgloseViajes() {
      const defaultState = {
        origen: "",
        destino: "",
        oneWayHours: { principal: 0, senior: 0, junior: 0 },
        returnTrips: { principal: 0, senior: 0, junior: 0 },
        workingDays: { principal: 0, senior: 0, junior: 0 },
        nonWorkingDays: { principal: 0, senior: 0, junior: 0 }
      };

      try {
        if (this.formItem.desgloseViajes) {
          this.travelData = JSON.parse(this.formItem.desgloseViajes);
        } else {
          this.travelData = JSON.parse(JSON.stringify(defaultState));
        }
      } catch (e) {
        console.error(e);
        this.travelData = JSON.parse(JSON.stringify(defaultState));
      }
      this.$refs['viajes-modal'].show();
    },
    cerrarDesgloseViajes() {
      // Sync totals back to formItem
      this.formItem.qtyTravelLS = this.travelTotalHours('principal');
      this.formItem.qtyTravelSenior = this.travelTotalHours('senior');
      this.formItem.qtyTravelJunior = this.travelTotalHours('junior');
      
      // const totalDaysPrincipal = (Number(this.travelData.workingDays.principal)||0) + (Number(this.travelData.nonWorkingDays.principal)||0);
      // const totalDaysSenior = (Number(this.travelData.workingDays.senior)||0) + (Number(this.travelData.nonWorkingDays.senior)||0);
      // const totalDaysJunior = (Number(this.travelData.workingDays.junior)||0) + (Number(this.travelData.nonWorkingDays.junior)||0);

      // Se elimina la asignación automática para que 'Living Allowances' y 'Hotel' se introduzcan a mano
      // this.formItem.qtyHotel = totalDaysPrincipal + totalDaysSenior + totalDaysJunior;
      // this.formItem.qtyLivingAllowances = this.formItem.qtyHotel;

      this.formItem.desgloseViajes = JSON.stringify(this.travelData);
      this.updateTotals();
      this.$refs['viajes-modal'].hide();
    },
    travelTotalHours(role) {
      const travelHours = (Number(this.travelData.oneWayHours[role]) || 0) * 2 * (Number(this.travelData.returnTrips[role]) || 0);
      const nonWorkingHours = (Number(this.travelData.nonWorkingDays[role]) || 0) * 8;
      return travelHours + nonWorkingHours;
    },
    travelTotalDays(role) {
      return (Number(this.travelData.workingDays[role]) || 0) + (Number(this.travelData.nonWorkingDays[role]) || 0);
    },
    confirmarBorrarVersion(version) {
      if (this.oferta.versiones.length <= 1) {
        this.$bvToast.toast("No puedes borrar la única versión de la oferta.", {
          title: "Aviso",
          variant: "warning",
          solid: true
        });
        return;
      }

      this.$bvModal.msgBoxConfirm(`¿Estás seguro de que deseas eliminar la versión "${version.revisionOferta}"? Esta acción no se puede deshacer.`, {
        title: 'Confirmar Eliminación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SÍ, BORRAR',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.borrarVersion(version);
        }
      });
    },
    borrarVersion(version) {
      api1.delete(`/api/dekra-projects/v204/oferta/version/${version.id}`)
        .then(() => {
          this.$bvToast.toast(`Versión "${version.revisionOferta}" eliminada correctamente.`, {
            title: "Éxito",
            variant: "success",
            solid: true
          });
          
          // Remove from local list
          this.oferta.versiones = this.oferta.versiones.filter(v => v.id !== version.id);
          
          // If we deleted the current version, switch to the first available one
          if (this.currentVersion && this.currentVersion.id === version.id) {
            if (this.oferta.versiones.length > 0) {
              this.seleccionarVersion(this.oferta.versiones[0]);
            } else {
              this.currentVersion = null;
            }
          }
        })
        .catch(err => {
          console.error(err);
          this.$bvToast.toast("Error al borrar la versión.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        });
    },
    getFormattedRevision(version) {
      if (!version || !version.revisionOferta) return "";
      const rev = version.revisionOferta.trim();
      if (rev === "R=" || rev === "R0" || rev === "0" || rev === "") return "";
      return " " + rev;
    },
    getAmpliacionSuffix(version) {
      if (version && version.ampliaciones && version.ampliaciones.length > 0) {
        return `_${version.ampliaciones[version.ampliaciones.length - 1]}`;
      }
      return "";
    },
    getOfferFullTitle(oferta, version) {
      const num = oferta.numeroOferta || "XXXXXXXX";
      const rev = this.getFormattedRevision(version);
      const amp = this.getAmpliacionSuffix(version);
      const label = version.ingles ? "OFFER NUMBER" : "OFERTA NÚMERO";
      return `${label} ${num}${rev}${amp}`;
    },
    getOfferFooterTitle(oferta, version) {
      const num = oferta.numeroOferta || "XXXXXXXX";
      const rev = this.getFormattedRevision(version);
      const amp = this.getAmpliacionSuffix(version);
      const label = version.ingles ? "OFFER" : "OFERTA";
      const cliente = oferta.cliente && oferta.cliente.nombre ? oferta.cliente.nombre : (version.ingles ? "CLIENT" : "CLIENTE");
      return `${label}  ${num}${rev}${amp} - ${cliente}`;
    },
    async generarPdfMake() {
      if (!this.currentVersion || !this.currentVersion.id) return;

      // Configuración de fuentes para pdfMake (incluyendo Noto Sans vía URL)
      pdfMake.fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf'
        },
        NotoSans: {
          normal: window.location.origin + '/fonts/NotoSans-Regular.ttf',
          bold: window.location.origin + '/fonts/NotoSans-Bold.ttf',
          italics: window.location.origin + '/fonts/NotoSans-Italic.ttf',
          bolditalics: window.location.origin + '/fonts/NotoSans-BoldItalic.ttf'
        }
      };

      const self = this;
      // Get sorted items for consistent order in PDF
      const sortedItems = [...this.currentVersion.items].sort((a, b) => {
        return (a.numeroItem || "").localeCompare((b.numeroItem || ""), undefined, { numeric: true, sensitivity: 'base' });
      });

      const clienteNombre = this.oferta.cliente && this.oferta.cliente.nombre ? this.oferta.cliente.nombre : "";
      const direccion = this.currentVersion.direccionClienteMemoria || "";
      const poblacion = this.currentVersion.poblacionClienteMemoria || this.oferta.ciudad || "";
      const cp = this.currentVersion.cpClienteMemoria || "";
      const pais = this.currentVersion.paisClienteMemoria || this.oferta.pais || "";
      const strPob = (cp + " " + poblacion).trim();
      const contacto = this.oferta.contactoOferta || "";

      // Calculate if any consulting item exists to switch table format
      const hasConsulting = sortedItems.some(item => item.seleccionado && !item.opcional && item.consultoriaPorHoras);
      const hasDiscounts = sortedItems.some(item => (item.seleccionado && item.porcentajeDescuento > 0) || item.esDescuento);

      const totalCommission = (this.currentVersion.comisionComercial) ? (this.calculatedCommercialCommission || 0) : 0;

      let itemsTableBody = [];
      if (hasConsulting) {
        // Special 3-column table for consulting
        itemsTableBody.push([
          { text: this.currentVersion.ingles ? 'Ref.' : 'Ref.', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Description' : 'Descripción', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Price/Unit' : 'Precio/Ud.', style: 'tableHeader', alignment: 'right' }
        ]);
      } else if (hasDiscounts) {
        itemsTableBody.push([
          { text: this.currentVersion.ingles ? 'Ref.' : 'Ref.', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Description' : 'Descripción', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Price' : 'Precio', style: 'tableHeader', alignment: 'right' },
          { text: this.currentVersion.ingles ? 'Quantity' : 'Cantidad', style: 'tableHeader', alignment: 'center' },
          { text: this.currentVersion.ingles ? 'Disc(%)' : 'Dto(%)', style: 'tableHeader', alignment: 'center' },
          { text: this.currentVersion.ingles ? 'Total price' : 'Precio total', style: 'tableHeader', alignment: 'right' }
        ]);
      } else {
        itemsTableBody.push([
          { text: this.currentVersion.ingles ? 'Ref.' : 'Ref.', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Description' : 'Descripción', style: 'tableHeader', alignment: 'left' },
          { text: this.currentVersion.ingles ? 'Price' : 'Precio', style: 'tableHeader', alignment: 'right' },
          { text: this.currentVersion.ingles ? 'Quantity' : 'Cantidad', style: 'tableHeader', alignment: 'center' },
          { text: this.currentVersion.ingles ? 'Total price' : 'Precio total', style: 'tableHeader', alignment: 'right' }
        ]);
      }

      let optionalTableBody = [];
      optionalTableBody.push([
        { text: this.currentVersion.ingles ? 'Ref.' : 'Ref.', style: 'tableHeader', alignment: 'left' },
        { text: this.currentVersion.ingles ? 'Description' : 'Descripción', style: 'tableHeader', alignment: 'left' },
        { text: this.currentVersion.ingles ? 'Price/unit' : 'Precio/unidad', style: 'tableHeader', alignment: 'right' }
      ]);

      let subtotal = 0;
      sortedItems.forEach(item => {
        if (!item.seleccionado || item.esDescuento || item.opcional) return;
        const localDiscountPct = (item.porcentajeDescuento || 0) / 100;
        const rawDiscountedPrice = (item.importeItem || 0) * (1 - localDiscountPct);
        const discountedPrice = Math.round(rawDiscountedPrice / 50) * 50;
        subtotal += discountedPrice;
      });

      let pdfTotal = 0;
      sortedItems.forEach(item => {
        if (!item.seleccionado) return;

        if (item.esDescuento) {
          // Standard Discount row
          let itemDiscount = subtotal * ((item.porcentajeDescuento || 0) / 100);
          itemDiscount = Math.round(itemDiscount / 50) * 50;
          pdfTotal -= itemDiscount;

          const discountAmountStr = (-itemDiscount).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const discountPctStr = (item.porcentajeDescuento || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

          if (hasDiscounts) {
            itemsTableBody.push([
              { text: item.numeroItem || "", alignment: 'left' },
              { 
                stack: [
                  { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                  (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
                ].filter(Boolean),
                alignment: 'left' 
              },
              { text: "", alignment: 'right' },
              { text: "1", alignment: 'center' },
              { text: discountPctStr, alignment: 'center' },
              { text: discountAmountStr, alignment: 'right' }
            ]);
          } else {
             itemsTableBody.push([
              { text: item.numeroItem || "", alignment: 'left' },
              { 
                stack: [
                  { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                  (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
                ].filter(Boolean),
                alignment: 'left' 
              },
              { text: "", alignment: 'right' },
              { text: "1", alignment: 'center' },
              { text: discountAmountStr, alignment: 'right' }
            ]);
          }
        } else if (item.opcional) {
          // Optional item - special table
          const exchangeRate = Number(item.currencyExchange) || 1;
          let basePriceRounded = 0;
          if (item.consultoriaPorHoras) {
            basePriceRounded = Math.round((item.importeItem || 0) * exchangeRate * 100) / 100;
          } else {
            basePriceRounded = Math.round(((item.importeItem || 0) * exchangeRate) / 50) * 50;
          }
          const localDiscountPct = (Number(item.porcentajeDescuento) || 0) / 100;
          const discountedPrice = basePriceRounded * (1 - localDiscountPct);
          
          const finalPriceStr = discountedPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

          optionalTableBody.push([
            { text: (item.numeroItem && item.numeroItem.startsWith("OPC") ? "" : "OPC") + (item.numeroItem || ""), alignment: 'left' },
            { 
              stack: [
                { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
              ].filter(Boolean),
              alignment: 'left' 
            },
            { text: finalPriceStr, alignment: 'right' }
          ]);
        } else {
          // Standard normal item
          const exchangeRate = Number(item.currencyExchange) || 1;
          let basePriceRounded = 0;
          if (item.consultoriaPorHoras) {
            basePriceRounded = Math.round((item.importeItem || 0) * exchangeRate * 100) / 100;
          } else {
            basePriceRounded = Math.round(((item.importeItem || 0) * exchangeRate) / 50) * 50;
          }
          
          let comm = 0;
          if (totalCommission > 0 && subtotal > 0 && !item.opcional) {
            const weight = basePriceRounded / subtotal;
            comm = Math.round(weight * totalCommission * 100) / 100;
          }
          
          let grossPriceRounded = 0;
          if (item.consultoriaPorHoras) {
            grossPriceRounded = Math.round((basePriceRounded + comm) * 100) / 100;
          } else {
            grossPriceRounded = Math.round((basePriceRounded + comm) / 50) * 50;
          }
          const localDiscountPct = (Number(item.porcentajeDescuento) || 0) / 100;
          const discountedPrice = grossPriceRounded * (1 - localDiscountPct);
          pdfTotal += discountedPrice;

          const visibleUnitPrice = grossPriceRounded;
          const unitPriceStr = visibleUnitPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const finalPriceStr = discountedPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const pctStr = item.porcentajeDescuento > 0 ? (item.porcentajeDescuento.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : "";

          if (hasConsulting) {
            // Price for consulting view
            let consultingPriceStr = "";
            if (item.consultoriaPorHoras) {
              const valUnidad = (item.importeUnidad || 0) * exchangeRate;
              consultingPriceStr = valUnidad.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €" + (item.unidadPrecio || "");
            } else {
              consultingPriceStr = finalPriceStr + " €";
            }

            itemsTableBody.push([
              { text: item.numeroItem || "", alignment: 'left' },
              { 
                stack: [
                  { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                  (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
                ].filter(Boolean),
                alignment: 'left' 
              },
              { text: consultingPriceStr, alignment: 'right' }
            ]);
          } else if (hasDiscounts) {
            itemsTableBody.push([
              { text: item.numeroItem || "", alignment: 'left' },
              { 
                stack: [
                  { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                  (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
                ].filter(Boolean),
                alignment: 'left' 
              },
              { text: unitPriceStr, alignment: 'right' },
              { text: "1", alignment: 'center' },
              { text: pctStr, alignment: 'center' },
              { text: finalPriceStr, alignment: 'right' }
            ]);
          } else {
            itemsTableBody.push([
              { text: item.numeroItem || "", alignment: 'left' },
              { 
                stack: [
                  { text: (this.currentVersion.ingles ? item.description : item.descripcion) || "" },
                  (item.notasItem ? { text: item.notasItem, fontSize: 9, margin: [0, 2, 0, 0] } : null)
                ].filter(Boolean),
                alignment: 'left' 
              },
              { text: unitPriceStr, alignment: 'right' },
              { text: "1", alignment: 'center' },
              { text: finalPriceStr, alignment: 'right' }
            ]);
          }
        }
      });

      // Condiciones de pago transform
      let condicionesRows = [];
      try {
        if (this.currentVersion.condicionesPagoIndependientes) {
          // Grouped by item, sorted by numeroItem
          const sortedItemsForCP = [...this.currentVersion.items].sort((a, b) => {
            const getNum = (s) => parseInt((s || "").toString().replace(/\D/g, '')) || 0;
            const numA = getNum(a.numeroItem);
            const numB = getNum(b.numeroItem);
            return numA - numB;
          });
          
          sortedItemsForCP.forEach(item => {
            if (item.esDescuento) return;
            if (item.hitosJson) {
              let hitos = JSON.parse(item.hitosJson);
              if (Array.isArray(hitos) && hitos.length > 0) {
                condicionesRows.push({ text: `Ref: ${item.numeroItem}`, bold: true, margin: [0, 5, 0, 2] });
                hitos.forEach(h => {
                  let pct = h.porcentaje || "";
                  if (pct && !pct.includes("%")) pct += " %";
                  let desc = this.currentVersion.ingles ? (h.description || "") : (h.descripcion || "");
                  condicionesRows.push({ text: `• ${pct} ${desc}`, margin: [10, 2, 0, 2] });
                });
              }
            }
          });
        } else if (this.currentVersion.hitosJson) {
          // Global
          let hitos = JSON.parse(this.currentVersion.hitosJson);
          if (Array.isArray(hitos)) {
            hitos.forEach(h => {
              let pct = h.porcentaje || "";
              if (pct && !pct.includes("%")) pct += " %";
              let desc = this.currentVersion.ingles ? (h.description || "") : (h.descripcion || "");
              condicionesRows.push({ text: `• ${pct} ${desc}`, margin: [10, 2, 0, 2] });
            });
          }
        }
        
        // Texto adicional de incumplimiento
        if (condicionesRows.length > 0) {
          const legalText = this.currentVersion.ingles ?
            [
              { text: "\nFailure to comply with payment terms:", margin: [0, 8, 0, 2], bold: true },
              { text: "• Will automatically accrue the default interest provided for in Law 3/2004, as amended by Law 15/2010, as well as the corresponding compensation for collection costs.", margin: [10, 2, 0, 2], fontSize: 9 },
              { text: "• Will empower the company to temporarily suspend service provision until regularization of outstanding amounts.", margin: [10, 2, 0, 2], fontSize: 9 }
            ] :
            [
              { text: "\nEl incumplimiento de los plazos de pago:", margin: [0, 8, 0, 2], bold: true },
              { text: "• Devengará automáticamente los intereses de demora previstos en la Ley 3/2004, modificada por la Ley 15/2010, así como la indemnización por costes de cobro correspondiente.", margin: [10, 2, 0, 2], fontSize: 9 },
              { text: "• Facultará a la empresa para suspender temporalmente la prestación del servicio hasta la regularización de las cantidades pendientes.", margin: [10, 2, 0, 2], fontSize: 9 }
            ];
          condicionesRows.push(...legalText);
        }
      } catch(e) { console.error("Error parseando hitosJson", e); }

      let docDefinition = {
        pageSize: 'A4',
        pageMargins: [ 40, 95, 40, 60 ],
        header: function () {
          return {
            margin: [0, 15, 0, 0],
            table: {
              widths: [65, 'auto', '*'],
              body: [
                [
                  {
                    image: logoencabezadotriangulopartido,
                    width: 50,
                    height: 80,
                    margin: [0, -10, 0, 0]
                  },
                  {
                    text: 'DEKRA Advisory & Training',
                    fontSize: 14,
                    bold: true,
                    color: '#00664f',
                    margin: [10, 25, 0, 0]
                  },
                  {
                    image: logoencabezadoladoderecho_plantillaofertas,
                    width: 25,
                    height: 33,
                    alignment: 'right',
                    margin: [0, 25, 20, 0]
                  }
                ]
              ]
            },
            layout: 'noBorders'
          };
        },
        footer: function(currentPage, pageCount) {
          return {
            margin: [40, 0, 40, 20],
            stack: [
              {
                canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5, lineColor: '#ccc' }],
                margin: [0, 5, 0, 5]
              },
              {
                columns: [
                  {
                    text: self.getOfferFooterTitle(self.oferta, self.currentVersion),
                    fontSize: 8,
                    color: '#666'
                  },
                  {
                    text: 'Página ' + currentPage + ' de ' + pageCount,
                    alignment: 'right',
                    fontSize: 8,
                    color: '#666'
                  }
                ]
              }
            ]
          };
        },
        content: [
          // Row 1: Title and Date
          {
            stack: [
              { text: self.getOfferFullTitle(self.oferta, self.currentVersion), bold: true, fontSize: 10, color: '#333333' },
              { 
                text: (this.currentVersion.ingles ? 'DATE: ' : 'FECHA: ') + new Date().toLocaleDateString(this.currentVersion.ingles ? 'en-GB' : 'es-ES'), 
                fontSize: 9, 
                margin: [0, 2, 0, 0] 
              }
            ],
            margin: [0, 0, 0, 20]
          },
          // Row 2: DEKRA (Left) and Client (Right)
          {
            columns: [
              {
                stack: [
                  { text: 'DEKRA Services SAU', bold: true, fontSize: 10 },
                  { text: 'ESA59790923', fontSize: 9 },
                  { text: 'Calle Calabozos, 12', fontSize: 9 },
                  { text: '28108 Alcobendas (Madrid)', fontSize: 9 },
                  { text: 'gestioncomercial.dat.es@dekra.com', fontSize: 9, color: '#333333', margin: [0, 2, 0, 0] }
                ],
                width: '*'
              },
              {
                stack: [
                  { text: clienteNombre, bold: true, fontSize: 10, alignment: 'right' },
                  { text: direccion, fontSize: 9, alignment: 'right' },
                  { text: strPob, fontSize: 9, alignment: 'right' },
                  { text: pais, fontSize: 9, alignment: 'right' },
                  { text: contacto, bold: true, fontSize: 9, alignment: 'right', margin: [0, 4, 0, 0] },
                  { text: (this.oferta.emailContacto || ""), fontSize: 9, alignment: 'right', color: '#333333' }
                ],
                width: 250
              }
            ],
            margin: [0, 0, 0, 40]
          },
          // Offer Heading
          {
            text: (this.oferta.alcance || (this.currentVersion.ingles ? "OFFER" : "OFERTA")) + (this.currentVersion.ingles ? ' for ' : ' para ') + clienteNombre,
            bold: true,
            fontSize: 12,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          },
          {
            text: this.currentVersion.ingles ? 
              'Thank you for your request. The pricing for the execution of the work is detailed in the table below' : 
              'Gracias por su solicitud. El precio para la realización de los trabajos se describe en la siguiente tabla.',
            fontSize: 9,
            margin: [0, 0, 0, 10]
          },
          // Items Table
          {
            table: {
              headerRows: 1,
              widths: hasConsulting ? [35, '*', 120] : (hasDiscounts ? [35, '*', 60, 45, 45, 65] : [35, '*', 60, 45, 65]),
              body: itemsTableBody
            },
            layout: {
               fillColor: function (rowIndex) {
                  if (rowIndex === 0) return '#017d41'; // Navbar green header
                  return (rowIndex % 2 === 0) ? '#f3f4f6' : null; // Zebra stripes
                },
               hLineWidth: function () { return 0.5; },
               vLineWidth: function () { return 0.5; },
               hLineColor: function () { return '#e9ecef'; },
               vLineColor: function () { return '#e9ecef'; }
            },
            margin: [0, 0, 0, 15]
          },
        // Row 4: Totals Summary (Only if NOT consulting)
!hasConsulting ? {
  margin: [0, 10, 0, 0],
  table: {
    widths: ['*', 120],
    body: [
      [
        {
          text: this.currentVersion.ingles
            ? 'Total price EUR'
            : 'Precio total EUR',
          bold: true,
          alignment: 'right',
          fontSize: 11,
          margin: [0, 5, 20, 5]
        },
        {
          text: pdfTotal.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),
          bold: true,
          alignment: 'right',
          fontSize: 11,
          margin: [0, 5, 0, 5]
        }
      ]
    ]
  },
  layout: 'noBorders'
} : null,
          // Opcionales Table
          ...(optionalTableBody.length > 1 ? [
            {
              text: this.currentVersion.ingles ? 'OPTIONALS' : 'OPCIONALES',
              bold: true,
              fontSize: 10,
              margin: [0, 10, 0, 5]
            },
            {
              table: {
                headerRows: 1,
                widths: ['auto', '*', 'auto'],
                body: optionalTableBody
              },
              layout: {
                 fillColor: function (rowIndex) {
                    if (rowIndex === 0) return '#017d41';
                    return (rowIndex % 2 === 0) ? '#f3f4f6' : null;
                  },
                 hLineWidth: function () { return 0.5; },
                 vLineWidth: function () { return 0.5; },
                 hLineColor: function () { return '#e9ecef'; },
                 vLineColor: function () { return '#e9ecef'; }
              },
              margin: [0, 0, 0, 15]
             }
           ] : [])
        ],
        styles: {
          tableHeader: {
            bold: true,
            fontSize: 9,
            color: 'white',
            fillColor: '#017d41'
          }
        },
        defaultStyle: {
          font: 'NotoSans',
          fontSize: 9,
          color: '#333333'
        }
      };

      // Add Notas if present
      let notasText = this.currentVersion.notasOferta ? this.currentVersion.notasOferta.trim() : "";
      if (notasText !== "") {
        // Traducir las notas de viaje al vuelo si están presentes y el idioma es inglés
        if (this.currentVersion.ingles) {
          notasText = notasText.replace(TRAVEL_NOTES_TEXT, TRAVEL_NOTES_TEXT_EN);
        } else {
          notasText = notasText.replace(TRAVEL_NOTES_TEXT_EN, TRAVEL_NOTES_TEXT);
        }

        docDefinition.content.push({
          margin: [0, 10, 0, 5],
          text: this.currentVersion.ingles ? 'NOTES:' : 'NOTAS:',
          fontSize: 10,
          bold: true,
          color: '#333333'
        });
        docDefinition.content.push({
          text: notasText,
          fontSize: 9,
          margin: [0, 0, 0, 20]
        });
      }

      // Condiciones de pago
      docDefinition.content.push({
        margin: [0, 10, 0, 5],
        text: this.currentVersion.ingles ? 'PAYMENT TERMS:' : 'CONDICIONES DE PAGO:',
        fontSize: 10,
        bold: true,
        color: '#333333'
      });

      // Obtener la descripción de cobro (o el nombre si no hay hitos)
      let cobroDesc = "";
      if (this.currentVersion.hitosCobro && this.currentVersion.hitosCobro.length > 0) {
        cobroDesc = this.currentVersion.ingles ? (this.currentVersion.hitosCobro[0].description || this.currentVersion.hitosCobro[0].descripcion) : this.currentVersion.hitosCobro[0].descripcion;
      } else {
        cobroDesc = this.currentVersion.condicionesCobro || "";
      }

      let combinedPaymentText = this.currentVersion.ingles ? 
        `Payment ${cobroDesc} via bank transfer to account ES34 0159 0001 3836 6734 2978, in accordance with the following milestones:` :
        `Pago ${cobroDesc} mediante transferencia bancaria a la cuenta ES34 0159 0001 3836 6734 2978, de acuerdo con los siguientes hitos: `;
      
      docDefinition.content.push({
        text: combinedPaymentText,
        fontSize: 9,
        margin: [0, 0, 0, 10]
      });

      // Pushing milestones AND legal text (which are both in condicionesRows)
      if (condicionesRows.length > 0) {
        docDefinition.content.push({
          stack: condicionesRows,
          margin: [0, 0, 0, 20]
        });
      }

      // Sales Conditions
      docDefinition.content.push({
        text: this.currentVersion.ingles ? 'SALES TERMS:' : 'CONDICIONES DE VENTA:',
        bold: true,
        fontSize: 10,
        margin: [0, 10, 0, 5]
      });

      const condVentaText = this.currentVersion.condicionesVenta || (this.currentVersion.ingles ? CONDICIONES_VENTA_TEXT_EN : CONDICIONES_VENTA_TEXT);
      
      // If the text is the default one, we keep the clickable link
      if (condVentaText === CONDICIONES_VENTA_TEXT || condVentaText === CONDICIONES_VENTA_TEXT_EN) {
        docDefinition.content.push({
          stack: [
            { text: this.currentVersion.ingles ? 'This price does not include VAT and is valid under the following conditions:\n\n' : 'Este precio no incluye IVA y es válido para las siguientes condiciones:\n\n' },
            { text: this.currentVersion.ingles ? '• Services to be performed during the current calendar year. For work carried out in the following year, prices will be updated according to the annual CPI increase in Spain, or a minimum of 2%.\n\n' : '• Servicios a realizar durante el año en curso. Para los trabajos desarrollados a partir del año siguiente, los precios se actualizarán de acuerdo al incremento del IPC anual en España, o como mínimo un 2%.\n\n', margin: [10, 0, 0, 0] },
            { text: this.currentVersion.ingles ? '• Services requested on an urgent basis will be subject to availability and may require resource rescheduling. In such cases, an additional surcharge will be applied to the total amount of the quotation, depending on the level of urgency required.\n\n' : '• Los servicios solicitados con carácter urgente estarán sujetos a disponibilidad y podrán implicar la reorganización de recursos. En estos casos, se aplicará un recargo adicional sobre el importe total del presupuesto, en función del nivel de urgencia requerido.\n\n', margin: [10, 0, 0, 0] },
            { text: this.currentVersion.ingles ? '• If the work is cancelled with less than 48 hours’ notice due to changes in planning, additional charges will apply for the unproductive time generated (idle time) and for any travel expenses already committed.\n\n' : '• En caso de cancelación de los trabajos con menos de 48 horas de antelación debido a cambios en la planificación, se aplicarán costes adicionales por el tiempo improductivo generado (idle time) y por los gastos de desplazamiento ya comprometidos.\n\n', margin: [10, 0, 0, 0] },
            { text: this.currentVersion.ingles ? '• In case of same day cancellation of the intervention, or if the service cannot be carried out on site due to reasons attributable to the client, 100% of the cost corresponding to the first scheduled service day will be invoiced.\n\n' : '• En caso de cancelación el mismo día de la intervención, o si el servicio no pudiera ejecutarse en el lugar por causas imputables al cliente, se facturará el 100% del coste correspondiente al primer día del servicio previsto.\n\n', margin: [10, 0, 0, 0] },
            { text: this.currentVersion.ingles ? '• This offer is valid for 90 days from its issue date. After this period, DEKRA reserves the right to review economic and service conditions.\n\n' : '• La presente oferta tiene una validez de 90 días desde su fecha de emisión. Transcurrido dicho plazo, DEKRA se reserva el derecho de revisar las condiciones económicas y de servicio.\n\n', margin: [10, 0, 0, 0] },
            { 
              text: [
                this.currentVersion.ingles ? '• The General Terms and Conditions of Sale applicable to this offer are available at the following link: ' : '• Las Condiciones Generales de Venta aplicables a la presente oferta están disponibles en el siguiente enlace: ',
                this.currentVersion.ingles
                  ? { text: 'general-terms-and-conditions-of-sale.pdf', link: CONDICIONES_VENTA_URL_EN, color: '#1a56db', decoration: 'underline' }
                  : { text: 'condiciones-generales-de-venta.pdf', link: CONDICIONES_VENTA_URL, color: '#1a56db', decoration: 'underline' }
              ],
              margin: [10, 0, 0, 0] 
            }
          ],
          fontSize: 9,
          margin: [0, 0, 0, 20]
        });
      } else {
        // If modified, we try to detect the URL to keep it pretty
        const currentUrl = this.currentVersion.ingles ? CONDICIONES_VENTA_URL_EN : CONDICIONES_VENTA_URL;
        const currentLabel = this.currentVersion.ingles ? 'general-terms-and-conditions-of-sale.pdf' : 'condiciones-generales-de-venta.pdf';
        
        let parts = condVentaText.split(currentUrl);
        const otherUrl = this.currentVersion.ingles ? CONDICIONES_VENTA_URL : CONDICIONES_VENTA_URL_EN;
        if (parts.length <= 1) {
          parts = condVentaText.split(otherUrl);
        }
        
        if (parts.length > 1) {
          const textArray = [];
          parts.forEach((p, i) => {
            textArray.push(p);
            if (i < parts.length - 1) {
              textArray.push({ text: currentLabel, link: currentUrl, color: '#1a56db', decoration: 'underline' });
            }
          });
          docDefinition.content.push({
            text: textArray,
            fontSize: 9,
            margin: [10, 0, 0, 20]
          });
        } else {
          docDefinition.content.push({
            text: condVentaText,
            fontSize: 9,
            margin: [10, 0, 0, 20]
          });
        }
      }

      // Aceptación
      docDefinition.content.push({
        unbreakable: true,
        stack: [
          {
            margin: [0, 20, 0, 5],
            text: this.currentVersion.ingles ? 'OFFER ACCEPTANCE:' : 'ACEPTACIÓN:',
            fontSize: 10,
            bold: true,
            color: '#333333'
          },
          {
            text: this.currentVersion.ingles ? [
              'If you accept this offer, please send a signed copy to ',
              { text: 'pedidos.dat.es@dekra.com', color: '#1a56db', decoration: 'underline' },
              '.'
            ] : [
              'En caso de aceptación de la presente oferta deberán enviar un ejemplar firmado a ',
              { text: 'pedidos.dat.es@dekra.com', color: '#1a56db', decoration: 'underline' },
              '.'
            ],
            alignment: 'left',
            margin: [0, 10, 0, 10]
          },
          {
            text: this.currentVersion.ingles ? 
              'The signing representative declares that they have full authority to sign this quotation and that such signature is binding for their organization with respect to the terms and conditions stated herein.' : 
              'El representante firmante declara que tiene plena autoridad para firmar este presupuesto y que dicha firma es vinculante para su organización respecto de los términos y condiciones expresados en el mismo.',
            fontSize: 9,
            margin: [0, 0, 0, 20]
          },
          {
            columns: [
              {
                stack: [
                  { text: (this.currentVersion.ingles ? 'By ' : 'Por ') + clienteNombre + ':', margin: [0, 0, 0, 15], bold: true },
                  { text: (this.currentVersion.ingles ? 'Name:' : 'Nombre:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'Position:' : 'Cargo:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'Date:' : 'Fecha:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'Company name:' : 'Razón social:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'VAT number:' : 'CIF:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'Billing address:' : 'Dirección fiscal:'), margin: [0, 0, 0, 15] },
                  { text: (this.currentVersion.ingles ? 'Signature and stamp:' : 'Firma y sello:'), margin: [0, 0, 0, 15] }
                ],
                width: '*'
              }
            ],
            margin: [0, 10, 0, 0]
          }
        ]
      });

      try {
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        
        pdfDocGenerator.getBuffer(async (buffer) => {
          try {
            const mergedPdf = await PDFDocument.create();

            // 2. Load the cover PDF (must be in /public folder)
            const isIngles = !!this.currentVersion.ingles;
            const baseUrl = process.env.BASE_URL || '/';
            const fileNameCover = isIngles ? 'PORTADA OFERTA 2026_EN.pdf' : 'PORTADA OFERTAS 2026.pdf';
            const coverUrl = (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + fileNameCover + '?v=' + new Date().getTime();
            
            const coverBytes = await fetch(coverUrl).then(async res => {
              if (!res.ok) throw new Error("Could not fetch cover PDF");
              return await res.arrayBuffer();
            });
             const coverDoc = await PDFDocument.load(coverBytes, { ignoreEncryption: true });
            
            // Draw dynamic cover fields on first page
            if (coverDoc.getPageCount() > 0) {
              const firstPage = coverDoc.getPages()[0];
              
              // Clear placeholders by drawing a white rectangle over them
              firstPage.drawRectangle({
                x: 190,
                y: 600,
                width: 390,
                height: 180,
                color: rgb(1, 1, 1),
              });
              
              // Load NotoSans custom fonts for the cover
              coverDoc.registerFontkit(fontkit);
              const fontBoldBytes = await fetch('/fonts/NotoSans-Bold.ttf').then(r => r.arrayBuffer());
              const fontRegularBytes = await fetch('/fonts/NotoSans-Regular.ttf').then(r => r.arrayBuffer());
              const fontBold = await coverDoc.embedFont(fontBoldBytes);
              const fontRegular = await coverDoc.embedFont(fontRegularBytes);
              
              const numOferta = (this.oferta.numeroOferta || '') + this.getFormattedRevision(this.currentVersion) + this.getAmpliacionSuffix(this.currentVersion);
              const nameCliente = clienteNombre;
              const nameOferta = this.oferta.alcance || '';
              
               // Format Date: Spanish: dd/mm/aaaa, English: aaaa/mm/dd
              const fechaActual = new Date();
              const dia = String(fechaActual.getDate()).padStart(2, '0');
              const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
              const anyo = fechaActual.getFullYear();
              const fechaTexto = isIngles ? `${anyo}/${mes}/${dia}` : `${dia}/${mes}/${anyo}`;
              
              // Draw "OFERTA [numeroOferta]"
              const labelOferta = isIngles ? 'OFFER' : 'OFERTA';
              firstPage.drawText(`${labelOferta} ${numOferta}`, {
                x: 191,
                y: 752,
                size: 14,
                font: fontBold,
                color: rgb(0, 0, 0),
              });
              
              // Draw "Para" / "For"
              const labelPara = isIngles ? 'For' : 'Para';
              firstPage.drawText(labelPara, {
                x: 191,
                y: 728,
                size: 12,
                font: fontRegular,
                color: rgb(0.2, 0.2, 0.2),
              });
              
              // Draw Client Name (wrapped if long)
              const drawTextWrapped = (text, x, y, size, font, color, lineSpacing = 16) => {
                const maxWidth = 370;
                const words = text.split(' ');
                let line = '';
                let currentY = y;
                
                for (let n = 0; n < words.length; n++) {
                  let testLine = line + words[n] + ' ';
                  let testWidth = font.widthOfTextAtSize(testLine, size);
                  if (testWidth > maxWidth && n > 0) {
                    firstPage.drawText(line.trim(), { x, y: currentY, size, font, color });
                    line = words[n] + ' ';
                    currentY -= lineSpacing;
                  } else {
                    line = testLine;
                  }
                }
                firstPage.drawText(line.trim(), { x, y: currentY, size, font, color });
                return currentY;
              };
              
              const clientEndY = drawTextWrapped(nameCliente, 191, 704, 14, fontBold, rgb(0, 0, 0));
              
              // Draw Date below client name with a margin
              const dateY = clientEndY - 24;
              firstPage.drawText(fechaTexto, {
                x: 191,
                y: dateY,
                size: 12,
                font: fontRegular,
                color: rgb(0.2, 0.2, 0.2),
              });
              
              // Draw Title (Offer Name) below date with a margin
              drawTextWrapped(nameOferta, 191, dateY - 24, 14, fontBold, rgb(0, 0, 0));
            }
            
            // 3. Copy cover pages exactly as they are
            const coverPages = await mergedPdf.copyPages(coverDoc, coverDoc.getPageIndices());
            coverPages.forEach(page => mergedPdf.addPage(page));
            
            // 4. Load the generated PDF from pdfMake and add its pages
            const mainDoc = await PDFDocument.load(buffer);
            const mainPages = await mergedPdf.copyPages(mainDoc, mainDoc.getPageIndices());
            mainPages.forEach(page => mergedPdf.addPage(page));
            
            // 6. Save and Download
            const mergedPdfBytes = await mergedPdf.save();
            const fileName = `Oferta_${this.oferta.numeroOferta}_${this.currentVersion.revisionOferta}.pdf`;
            
            download(mergedPdfBytes, fileName, "application/pdf");
          } catch (mergeError) {
            console.error("Error merging cover PDF, downloading original:", mergeError);
            pdfDocGenerator.download(`Oferta_${this.oferta.numeroOferta}_${this.currentVersion.revisionOferta}.pdf`);
          }
        });
      } catch (e) {
        console.error("Error creating PDF", e);
      }
    },
    openTravelExpensesModal(type) {
      this.expenseTypeForModal = type;
      this.$bvModal.show('modal-travel-expenses');
    },
    agregarAmpliacion() {
      if (!this.nuevaAmpliacionNumero || this.nuevaAmpliacionNumero.toString().trim() === "") return;
      if (!this.currentVersion.ampliaciones) this.$set(this.currentVersion, 'ampliaciones', []);
      this.currentVersion.ampliaciones.push(this.nuevaAmpliacionNumero.toString().trim());
      this.nuevaAmpliacionNumero = "";
    },
    eliminarAmpliacion(index) {
      if (this.currentVersion.ampliaciones) {
        this.currentVersion.ampliaciones.splice(index, 1);
      }
    },
    toggleTravelNotes(checked) {
      const textToUse = this.currentVersion.ingles ? TRAVEL_NOTES_TEXT_EN : TRAVEL_NOTES_TEXT;
      const otherText = this.currentVersion.ingles ? TRAVEL_NOTES_TEXT : TRAVEL_NOTES_TEXT_EN;
      
      if (checked) {
        if (!this.currentVersion.notasOferta) {
          this.currentVersion.notasOferta = textToUse;
        } else if (!this.currentVersion.notasOferta.includes(textToUse)) {
          // Remove the other language version if present to avoid duplication when switching
          let cleaned = this.currentVersion.notasOferta.replace(otherText, '').trim();
          // Add a newline if there's already content and it doesn't end with one
          this.currentVersion.notasOferta = cleaned + (cleaned ? "\n" : "") + textToUse;
        }
      } else {
        if (this.currentVersion.notasOferta) {
          // Remove the text and trim
          this.currentVersion.notasOferta = this.currentVersion.notasOferta.replace(textToUse, '').trim();
        }
      }
    }
  }
};
</script>

<style scoped>
.excel-row {
  display: flex;
  border-bottom: 1px solid black;
  min-height: 38px;
}
.excel-row:last-child {
  border-bottom: none;
}
.excel-label {
  flex: 0 0 20%;
  background-color: #ffffff;
  border-right: 1px solid black;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.85rem;
  color: #000;
  text-align: right;
}
.excel-val {
  flex: 0 0 30%;
  background-color: #f2f2f2;
  border-right: 1px solid black;
  display: flex;
  align-items: center;
}
.excel-val:last-child {
  border-right: none;
}
.excel-val-full {
  flex: 0 0 80%;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
}
.border-0 {
  border: none !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.header-version-badge {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 6px 20px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
}
.ganada-switch-wrapper {
  transition: all 0.3s ease;
}
.ganada-switch-wrapper:hover {
  background-color: #f8f9fa !important;
  border-color: #28a745 !important;
}
.uppercase {
  text-transform: uppercase;
}
.custom-dropdown .dropdown-toggle {
  border-radius: 20px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.dropdown-item-version .dropdown-item {
  padding: 0.5rem 1rem !important;
}
.dropdown-item-version .dropdown-item:hover {
  background-color: #f8f9fa !important;
}
.dropdown-item-version .btn-link:hover {
  transform: scale(1.2);
  transition: transform 0.2s;
}
.btn-clonar-custom {
  color: #f59e0b !important;
  border-color: #f59e0b !important;
  background-color: transparent;
}
.btn-clonar-custom:hover {
  background-color: #f59e0b !important;
  color: white !important;
}
</style>

<style scoped>
.dropzone {
    border: 3px dashed #cbd5e0;
    border-radius: 12px;
    padding: 3rem 2rem;
    text-align: center;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-spacing: 10px;
}
.dropzone:hover {
    background: #edf2f7;
    border-color: #a0aec0;
}
.dropzone.active {
    border-color: #48bb78;
    background: #f0fff4;
    transform: scale(1.01);
}
.file-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
}
.file-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    transition: transform 0.2s;
}
.file-item:hover {
    transform: translateY(-2px);
    border-color: #cbd5e0;
}
</style>
